/* ============================================================
   FROG HUNT — Community Game Finder Frontend
   FroGames.it
   ============================================================ */
(function () {
  'use strict';
  /* Testi dal tema (window.FH_T, 7 set 2026): l'italiano resta come riserva. */
  var FH_T = window.FH_T || {};
  // Shopify passa le traduzioni con gli apostrofi gia' in entita' HTML (c&#39;e'): va bene
  // dentro innerHTML, ma dove il testo finisce in textContent (le didascalie dei segmenti)
  // l'entita' si vedeva a schermo. Decodifico qui, una volta per tutte.
  function t(k, fallback) { return decodeHtmlEntities((FH_T[k] != null && FH_T[k] !== '') ? FH_T[k] : fallback); }

  // ── CONFIG ──────────────────────────────────────────────
  // IMPORTANTE: aggiorna questo URL dopo il deploy del Worker
  var WORKER_URL = 'https://froghunt.info-frogames.workers.dev';

  var cfg = window.__frogHunt || {};
  var customerId = cfg.customerId;
  var customerName = cfg.customerName || '';
  var isAdmin = cfg.isAdmin || false;
  var loginUrl = cfg.loginUrl || '/account/login';

  // ── STATE ───────────────────────────────────────────────
  var state = {
    hunts: [],
    myHuntSlugs: [],
    myPurchased: {},   // slug -> data acquisto (solo le MIE: un acquisto e' personale)
    stats: null,
    view: 'browse',
    filterStatus: 'all',
    sort: 'recent',
    query: '',
    loading: true,
    selectedHunt: null,
    pendingFollowSlug: null,
    bggData: null
  };

  // ── DOM REFS ────────────────────────────────────────────
  var $grid = document.getElementById('fhGrid');
  var $search = document.getElementById('fhSearchInput');
  var $sort = document.getElementById('fhSort');
  var $toast = document.getElementById('fhToast');
  var $detailModal = document.getElementById('fhDetailModal');
  var $detailBody = document.getElementById('fhDetailBody');
  var $detailTitle = document.getElementById('fhDetailTitle');
  var $proposeModal = document.getElementById('fhProposeModal');
  var $telegramModal = document.getElementById('fhTelegramModal');
  var $bggInput = document.getElementById('fhBggInput');
  var $bggPreview = document.getElementById('fhBggPreview');
  var $proposeError = document.getElementById('fhProposeError');

  // ── INIT ────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', init);
  // Fallback for deferred scripts
  if (document.readyState !== 'loading') init();

  var initialized = false;
  function init() {
    if (initialized) return;
    initialized = true;

    bindEvents();
    loadData();
    handleDeepLink();
  }

  // ── EVENTS ──────────────────────────────────────────────
  function bindEvents() {
    // Nav tabs
    document.querySelectorAll('.fh-nav__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.getAttribute('data-view'));
      });
    });

    // Filter pills
    document.querySelectorAll('.fh-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        document.querySelectorAll('.fh-pill').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        state.filterStatus = pill.getAttribute('data-status');
        renderGrid();
      });
    });

    // Search
    $search.addEventListener('input', debounce(function () {
      state.query = $search.value.trim().toLowerCase();
      renderGrid();
    }, 250));

    // Sort
    $sort.addEventListener('change', function () {
      state.sort = $sort.value;
      renderGrid();
    });

    // Propose CTA
    document.getElementById('fhProposeCta').addEventListener('click', function () {
      if (!customerId) { window.location.href = loginUrl; return; }
      openProposeModal();
    });

    // Propose close
    document.getElementById('fhProposeClose').addEventListener('click', closeProposeModal);
    $proposeModal.addEventListener('click', function (e) { if (e.target === $proposeModal) closeProposeModal(); });

    // Detail close
    document.getElementById('fhDetailClose').addEventListener('click', closeDetailModal);
    $detailModal.addEventListener('click', function (e) { if (e.target === $detailModal) closeDetailModal(); });

    // Telegram modal close
    document.getElementById('fhTelegramClose').addEventListener('click', closeTelegramModal);
    $telegramModal.addEventListener('click', function (e) { if (e.target === $telegramModal) closeTelegramModal(); });

    // BGG input — smart search: URL BGG → preview diretta / testo → ricerca visiva
    var bggDebounce = debounce(function () {
      var val = $bggInput.value.trim();
      var searchEl = document.getElementById('fhBggSearchResults');
      // Se sembra un URL BGG → preview diretta (comportamento vecchio)
      if (val && (val.includes('boardgamegeek.com/boardgame/') || val.includes('boardgamegeek.com/boardgameexpansion/'))) {
        if (searchEl) { searchEl.hidden = true; searchEl.innerHTML = ''; }
        fetchBggPreview(val);
        return;
      }
      // Se testo >= 3 caratteri → ricerca visiva
      if (val.length >= 3) {
        $bggPreview.innerHTML = '';
        state.bggData = null;
        fetchBggSearchResults(val);
        return;
      }
      // Reset
      $bggPreview.innerHTML = '';
      state.bggData = null;
      if (searchEl) { searchEl.hidden = true; searchEl.innerHTML = ''; }
    }, 500);
    $bggInput.addEventListener('input', bggDebounce);

    // Propose submit
    document.getElementById('fhProposeSubmit').addEventListener('click', submitProposal);

    // Multi-select chip lingua (per follow) — bind diretto per-chip + debounce anti double-fire
    var langChipsEl = document.getElementById('fhFollowLangChips');
    if (langChipsEl) {
      langChipsEl.querySelectorAll('.fh-lang-chip').forEach(function(chip){
        chip.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          var now = Date.now();
          if (chip._lastLangClick && (now - chip._lastLangClick) < 300) return;
          chip._lastLangClick = now;
          chip.classList.toggle('is-active');
          var active = langChipsEl.querySelectorAll('.fh-lang-chip.is-active');
          if (active.length === 0) chip.classList.add('is-active');
        });
      });
    }
    function getSelectedLanguages(){
      if (!langChipsEl) return ['IT'];
      var chips = langChipsEl.querySelectorAll('.fh-lang-chip.is-active');
      var out = [];
      chips.forEach(function(c){ out.push(c.getAttribute('data-lang')); });
      return out.length ? out : ['IT'];
    }
    window.__fhGetLangs = getSelectedLanguages; // esposto per submitProposal

    // Machine of War: multi-select lingua nel modal PROPONI — bind diretto per-chip
    // + debounce 300ms per bloccare double-fire (FB pixel / touch double-tap)
    var proposeLangChipsEl = document.getElementById('fhProposeLangChips');
    if (proposeLangChipsEl) {
      proposeLangChipsEl.querySelectorAll('.fh-lang-chip').forEach(function(chip){
        chip.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          var now = Date.now();
          if (chip._lastLangClick && (now - chip._lastLangClick) < 300) return;
          chip._lastLangClick = now;
          chip.classList.toggle('is-active');
          var active = proposeLangChipsEl.querySelectorAll('.fh-lang-chip.is-active');
          if (active.length === 0) chip.classList.add('is-active');
        });
      });
    }
    function getProposeLanguages(){
      if (!proposeLangChipsEl) return ['IT'];
      var chips = proposeLangChipsEl.querySelectorAll('.fh-lang-chip.is-active');
      var out = [];
      chips.forEach(function(c){ out.push(c.getAttribute('data-lang')); });
      return out.length ? out : ['IT'];
    }
    window.__fhGetProposeLangs = getProposeLanguages;

    // Machine of War: single-select tipo proposta (retail / KS / Gamefound)
    // + campo URL campagna + checkbox conferma "campagna attiva" (obbligatoria per KS/GF)
    var ptypeChipsEl = document.getElementById('fhProposeTypeChips');
    var campaignUrlEl = document.getElementById('fhCampaignUrl');
    var campConfirmBox = document.getElementById('fhCampaignConfirmBox');
    var campConfirmCheck = document.getElementById('fhCampaignConfirm');
    var campUrlWarn = document.getElementById('fhCampaignUrlWarn');
    var submitBtn = document.getElementById('fhProposeSubmit');

    // Aggiorna stato submit in base a: tipo proposta + checkbox conferma
    function updateProposeSubmitState(){
      if (!submitBtn) return;
      var ptype = ptypeChipsEl ? (ptypeChipsEl.getAttribute('data-selected') || 'retail') : 'retail';
      if (ptype === 'kickstarter' || ptype === 'gamefound') {
        var checked = campConfirmCheck && campConfirmCheck.checked;
        submitBtn.disabled = !checked;
        submitBtn.style.opacity = checked ? '' : '.5';
        submitBtn.style.cursor = checked ? '' : 'not-allowed';
      } else {
        submitBtn.disabled = false;
        submitBtn.style.opacity = '';
        submitBtn.style.cursor = '';
      }
    }
    // Validazione soft URL campagna
    function checkCampaignUrlWarn(){
      if (!campUrlWarn || !campaignUrlEl) return;
      var url = campaignUrlEl.value.trim().toLowerCase();
      var ptype = ptypeChipsEl ? (ptypeChipsEl.getAttribute('data-selected') || 'retail') : 'retail';
      if (!url || (ptype !== 'kickstarter' && ptype !== 'gamefound')) {
        campUrlWarn.style.display = 'none';
        return;
      }
      var looksOk = (ptype === 'kickstarter' && url.indexOf('kickstarter.com') !== -1)
                 || (ptype === 'gamefound'   && url.indexOf('gamefound.com')   !== -1);
      campUrlWarn.style.display = looksOk ? 'none' : '';
    }

    if (ptypeChipsEl) {
      ptypeChipsEl.addEventListener('click', function(e){
        var btn = e.target.closest('.fh-lang-chip');
        if (!btn) return;
        e.preventDefault();
        ptypeChipsEl.querySelectorAll('.fh-lang-chip').forEach(function(c){ c.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var ptype = btn.getAttribute('data-ptype');
        ptypeChipsEl.setAttribute('data-selected', ptype);
        var isCampaign = (ptype === 'kickstarter' || ptype === 'gamefound');
        if (campaignUrlEl) {
          campaignUrlEl.style.display = isCampaign ? '' : 'none';
          campaignUrlEl.placeholder = ptype === 'kickstarter'
            ? 'Link campagna Kickstarter (opzionale)'
            : (ptype === 'gamefound' ? 'Link campagna Gamefound (opzionale)' : 'Link campagna (opzionale)');
          if (!isCampaign) campaignUrlEl.value = '';
        }
        if (campConfirmBox) campConfirmBox.style.display = isCampaign ? '' : 'none';
        if (campConfirmCheck) campConfirmCheck.checked = false;
        checkCampaignUrlWarn();
        updateProposeSubmitState();
      });
    }
    if (campConfirmCheck) {
      campConfirmCheck.addEventListener('change', updateProposeSubmitState);
    }
    if (campaignUrlEl) {
      campaignUrlEl.addEventListener('input', checkCampaignUrlWarn);
    }

    function getProposalType(){
      return ptypeChipsEl ? (ptypeChipsEl.getAttribute('data-selected') || 'retail') : 'retail';
    }
    function getCampaignUrl(){
      return (campaignUrlEl && campaignUrlEl.value) ? campaignUrlEl.value.trim() : '';
    }
    function isCampaignConfirmed(){
      return campConfirmCheck ? campConfirmCheck.checked : true;
    }
    window.__fhGetPtype = getProposalType;
    window.__fhGetCampaignUrl = getCampaignUrl;
    window.__fhIsCampaignConfirmed = isCampaignConfirmed;
    window.__fhUpdateProposeSubmit = updateProposeSubmitState;

    // Follow confirm
    document.getElementById('fhFollowConfirm').addEventListener('click', function () {
      var tg = document.getElementById('fhFollowTelegram').value.trim();
      var langs = getSelectedLanguages();
      confirmFollow(state.pendingFollowSlug, tg, langs);
    });
    document.getElementById('fhFollowSkip').addEventListener('click', function () {
      var langs = getSelectedLanguages();
      confirmFollow(state.pendingFollowSlug, '', langs);
    });

    // Grid delegation
    $grid.addEventListener('click', function (e) {
      var card = e.target.closest('.fh-card');
      var ctaBtn = e.target.closest('.fh-card__frogger-cta');
      var adminSave = e.target.closest('.fh-card__admin-save');

      if (adminSave) {
        e.stopPropagation();
        var slug = adminSave.getAttribute('data-slug');
        adminUpdateFromCard(slug);
        return;
      }

      if (ctaBtn) {
        e.stopPropagation();
        var slug = ctaBtn.getAttribute('data-slug');
        handleFollowClick(slug);
        return;
      }

      if (card) {
        var slug = card.getAttribute('data-slug');
        openDetailModal(slug);
      }
    });

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDetailModal();
        closeProposeModal();
        closeTelegramModal();
      }
    });
  }

  // ── DATA LOADING ────────────────────────────────────────
  function loadData() {
    state.loading = true;
    var promises = [
      apiGet('/api/hunts').then(function (data) { state.hunts = data || []; }),
      apiGet('/api/stats').then(function (data) { state.stats = data; })
    ];
    if (customerId) {
      promises.push(
        apiPost('/api/hunts', { action: 'my-hunts', customerId: String(customerId) })
          .then(function (data) {
            state.myHuntSlugs = (data && data.slugs) ? data.slugs : [];
            state.myPurchased = (data && data.purchased) ? data.purchased : {};
          })
          .catch(function () { state.myHuntSlugs = []; state.myPurchased = {}; })
      );
    }
    Promise.all(promises).then(function () {
      state.loading = false;
      renderStats();
      renderGrid();
      // Trending: hunts with most NEW followers in the last 7 days.
      // Exclude found/out_of_print/unavailable (dead hunts shouldn't show up front).
      var DEAD_STATUSES = ['found', 'out_of_print', 'unavailable'];
      state.trending = state.hunts
        .filter(function (h) {
          return DEAD_STATUSES.indexOf(h.status) === -1 && (h.weeklyFroggerCount || 0) >= 1;
        })
        .sort(function (a, b) {
          var diff = (b.weeklyFroggerCount || 0) - (a.weeklyFroggerCount || 0);
          if (diff !== 0) return diff;
          // Tiebreak by total froggers
          return (b.froggerCount || 0) - (a.froggerCount || 0);
        })
        .slice(0, 8);
      // V2: rails sostituiscono renderTrending — niente duplicato dentro accordion
      // if (state.view === 'browse' && state.trending.length) renderTrending();
      // #2A: se torno dal login con una segui in sospeso, la completo automaticamente
      resumePendingFollow();
    }).catch(function (err) {
      state.loading = false;
      console.error('Frog Hunt load error:', err);
      renderGrid();
    });
  }

  // ── API HELPERS ─────────────────────────────────────────
  function apiGet(path) {
    return fetch(WORKER_URL + path).then(function (r) {
      if (!r.ok) throw new Error('API error ' + r.status);
      return r.json();
    });
  }

  function apiPost(path, body) {
    return fetch(WORKER_URL + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ── RENDER: STATS ───────────────────────────────────────
  function renderStats() {
    if (!state.stats) return;
    var s = state.stats;
    setText('fhStatProposed', s.proposed || 0);
    setText('fhStatSearching', s.searching);
    setText('fhStatFound', s.found);
    setText('fhStatFroggers', s.totalFroggers);
  }

  function setText(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  // ── RENDER: GRID ────────────────────────────────────────
  // "Preso" e' PERSONALE: vale solo per chi l'ha comprato. Se sparisse per tutti,
  // il primo acquirente nasconderebbe il gioco a chi lo sta ancora aspettando.
  function isPurchasedByMe(slug) {
    return !!(state.myPurchased && Object.prototype.hasOwnProperty.call(state.myPurchased, slug));
  }
  function purchasedAtByMe(slug) {
    return (state.myPurchased && state.myPurchased[slug]) || null;
  }
  // Comparatore: i miei presi vanno in fondo, come gli introvabili. Dentro al gruppo
  // resta l'ordine del segmento.
  function purchasedLast(sortFn) {
    return function (a, b) {
      var pa = isPurchasedByMe(a.slug) ? 1 : 0;
      var pb = isPurchasedByMe(b.slug) ? 1 : 0;
      if (pa !== pb) return pa - pb;
      return sortFn(a, b);
    };
  }

  function renderGrid() {
    if (state.loading) return;

    var hunts = getFilteredHunts();
    var prefix = '';

    // My stats in "Sto Cercando" view
    if (state.view === 'my-hunts') {
      prefix = renderMyStats();
    }

    // V2: rail "Trovati di recente" gia\' nella pagina principale, niente duplicato qui
    // if (state.view === 'browse' && state.filterStatus === 'all' && !state.query) {
    //   prefix += renderHallOfFame();
    // }

    if (!hunts.length) {
      $grid.innerHTML = prefix + renderEmpty();
      return;
    }

    cardRenderCount = 0;
    $grid.innerHTML = prefix + hunts.map(function (h) { return renderCard(h); }).join('');

    // SEO: inject JSON-LD for games (only on browse view, first render)
    if (state.view === 'browse' && !document.getElementById('fhSeoSchema')) {
      var seoHunts = hunts.slice().sort(function(a,b){ return (b.froggerCount||0)-(a.froggerCount||0); });
      var schemaItems = seoHunts.slice(0, 50).map(function (h) {
        var item = {
          '@type': 'Game',
          'name': h.name,
          'url': 'https://frogames.it/pages/froghunt?hunt=' + h.slug
        };
        if (h.image) item.image = h.image;
        if (h.year) item.datePublished = String(h.year);
        if (h.bggRating) item.aggregateRating = { '@type': 'AggregateRating', ratingValue: h.bggRating.toFixed(1), bestRating: '10', ratingCount: h.froggerCount || 1 };
        if (h.minPlayers && h.maxPlayers) item.numberOfPlayers = { '@type': 'QuantitativeValue', minValue: h.minPlayers, maxValue: h.maxPlayers };
        if (h.bggUrl) item.sameAs = h.bggUrl;
        return item;
      });
      var schema = document.createElement('script');
      schema.type = 'application/ld+json';
      schema.id = 'fhSeoSchema';
      schema.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        'name': 'Frog Hunt - Giochi da Tavolo Cercati dalla Community',
        'description': 'La community italiana di cacciatori di giochi da tavolo. Cerca giochi rari e introvabili.',
        'numberOfItems': schemaItems.length,
        'itemListElement': schemaItems.map(function (item, i) {
          return { '@type': 'ListItem', position: i + 1, item: item };
        })
      });
      document.head.appendChild(schema);
    }
  }

  function getFilteredHunts() {
    var hunts = state.hunts;

    // View filter
    if (state.view === 'my-hunts') {
      hunts = hunts.filter(function (h) { return state.myHuntSlugs.indexOf(h.slug) !== -1; });
    }

    // Status filter
    if (state.filterStatus !== 'all') {
      hunts = hunts.filter(function (h) { return h.status === state.filterStatus; });
    }

    // Search
    if (state.query) {
      hunts = hunts.filter(function (h) {
        return h.name.toLowerCase().indexOf(state.query) !== -1 ||
          (h.categories || []).some(function (c) { return c.toLowerCase().indexOf(state.query) !== -1; });
      });
    }

    // Sort (i gia' presi scendono in fondo)
    hunts = hunts.slice().sort(purchasedLast(function (a, b) {
      if (state.sort === 'froggers') return (b.froggerCount || 0) - (a.froggerCount || 0);
      if (state.sort === 'updated') return new Date(b.updatedAt) - new Date(a.updatedAt);
      if (state.sort === 'rating') return (b.bggRating || 0) - (a.bggRating || 0);
      return new Date(b.proposedAt) - new Date(a.proposedAt);
    }));

    return hunts;
  }

  // ── RENDER: CARD ────────────────────────────────────────
  var cardRenderCount = 0;
  function renderCard(h) {
    cardRenderCount++;
    var isFollowing = state.myHuntSlugs.indexOf(h.slug) !== -1;
    var cardImg = cardImageUrl(h.image || h.thumbnail);
    // First 6 cards: load immediately. Rest: lazy load
    var lazyAttr = cardRenderCount > 6 ? ' loading="lazy"' : '';
    var imgHtml = cardImg
      ? '<img class="fh-card__image" src="' + escHtml(cardImg) + '" alt="' + escHtml(h.name) + '"' + lazyAttr + '>'
      : '<div class="fh-card__no-image">&#x1F3B2;</div>';

    var badgeClass = 'fh-badge fh-badge--' + h.status;
    var badgeText = statusLabel(h.status);
    // Gia' comprato da me: il badge dice "Preso", non "Trovato" (che invitava a comprare
    // una cosa che ho gia' in casa).
    if (isPurchasedByMe(h.slug)) {
      badgeClass = 'fh-badge fh-badge--preso';
      badgeText = t('preso', '\u2714 Preso');
    }

    var metaHtml = '';
    if (h.year) metaHtml += '<span class="fh-card__meta-item"><span class="fh-card__meta-icon">&#x1F4C5;</span> ' + h.year + '</span>';
    if (h.minPlayers && h.maxPlayers) metaHtml += '<span class="fh-card__meta-item"><span class="fh-card__meta-icon">&#x1F465;</span> ' + h.minPlayers + '-' + h.maxPlayers + '</span>';
    if (h.playingTime) metaHtml += '<span class="fh-card__meta-item"><span class="fh-card__meta-icon">&#x23F1;</span> ' + h.playingTime + ' min</span>';

    var catsHtml = '';
    if (h.categories && h.categories.length) {
      catsHtml = '<div class="fh-card__cats">' + h.categories.slice(0, 3).map(function (c) {
        return '<span class="fh-card__cat">' + escHtml(c) + '</span>';
      }).join('') + '</div>';
    }

    var ctaClass = 'fh-card__frogger-cta' + (isFollowing ? ' fh-card__frogger-cta--following' : '');
    var ctaText = isFollowing ? t('segui_gia', '\u2714 Segui gi\u00e0') : t('diventa_frogger', 'Diventa Frogger');

    var bggBadge = '';
    if (h.bggRating && h.bggRating > 0) {
      bggBadge = '<span class="fh-bgg-badge">BGG ' + h.bggRating.toFixed(1) + '</span>';
    }

    var noteHtml = '';
    if (h.statusNote) {
      noteHtml = '<div class="fh-card__note">' +
        '<span class="fh-card__note-icon">&#x1F4AC;</span>' +
        '<span class="fh-card__note-text">' + escHtml(h.statusNote) + '</span>' +
      '</div>';
    }

    var adminHtml = '';
    if (isAdmin) {
      adminHtml = '<div class="fh-card__admin">' +
        '<select data-admin-status="' + h.slug + '">' +
          '<option value="proposed"' + (h.status === 'proposed' ? ' selected' : '') + '>Proposto</option>' +
          '<option value="searching"' + (h.status === 'searching' ? ' selected' : '') + '>In Ricerca</option>' +
          '<option value="ordered"' + (h.status === 'ordered' ? ' selected' : '') + '>Ordinato</option>' +
          '<option value="found"' + (h.status === 'found' ? ' selected' : '') + '>Trovato!</option>' +
          '<option value="out_of_print"' + (h.status === 'out_of_print' ? ' selected' : '') + '>Fuori Prod.</option>' +
          '<option value="unavailable"' + (h.status === 'unavailable' ? ' selected' : '') + '>Non Disp.</option>' +
        '</select>' +
        '<input data-admin-note="' + h.slug + '" placeholder="Nota..." value="' + escHtml(h.statusNote || '') + '">' +
        '<button class="fh-card__admin-save" data-slug="' + h.slug + '">Salva</button>' +
      '</div>';
    }

    return '<article class="fh-card" data-slug="' + h.slug + '">' +
      '<div class="fh-card__image-wrap">' +
        imgHtml +
        '<span class="' + badgeClass + '">' + badgeText + '</span>' +
        bggBadge +
      '</div>' +
      '<div class="fh-card__body">' +
        '<h3 class="fh-card__title">' + escHtml(h.name) + '</h3>' +
        (h.year ? '<span class="fh-card__year">' + h.year + '</span>' : '') +
        '<div class="fh-card__bgg-inline">' +
          (h.bggRating ? '<span class="fh-card__bgg-tag">&#x2B50; ' + h.bggRating.toFixed(1) + '</span>' : '') +
          (h.bggRank ? '<span class="fh-card__bgg-tag">&#x1F3C6; #' + h.bggRank + '</span>' : '') +
        '</div>' +
        (metaHtml ? '<div class="fh-card__meta">' + metaHtml + '</div>' : '') +
        catsHtml +
        noteHtml +
        '<div class="fh-card__froggers">' +
          '<span class="fh-card__frogger-icon"><img src="https://cdn.shopify.com/s/files/1/0887/8905/7863/files/logo_9581a5e6-925f-4c66-ab2c-708dac0606f5.png?v=1775011264" alt="" class="fh-logo-icon"></span>' +
          '<span class="fh-card__frogger-count">' + (h.froggerCount || 0) + '</span>' +
          '<span class="fh-card__frogger-label">Frogger' + (h.froggerCount !== 1 ? 's' : '') + '</span>' +
          '<button class="' + ctaClass + '" data-slug="' + h.slug + '">' + ctaText + '</button>' +
        '</div>' +
        (h.shopifyProductUrl && h.status === 'found' ?
          '<a href="' + escHtml(h.shopifyProductUrl) + '" class="fh-card__product-link" onclick="event.stopPropagation()">&#x1F6D2; ' + t('acquista', 'Acquista') + '</a>' : '') +
      '</div>' +
      adminHtml +
    '</article>';
  }

  function renderEmpty() {
    if (state.view === 'my-hunts' && !customerId) {
      return '<div class="fh-login-prompt">' +
        '<p class="fh-login-prompt__title">Accedi per vedere i giochi che cerchi</p>' +
        '<p class="fh-login-prompt__text">Effettua il login per seguire le ricerche e diventare Frogger</p>' +
        '<a href="' + loginUrl + '" class="fh-login-prompt__btn">Accedi</a>' +
      '</div>';
    }
    if (state.view === 'my-hunts') {
      return '<div class="fh-empty">' +
        '<span class="fh-empty__icon"><img src="https://cdn.shopify.com/s/files/1/0887/8905/7863/files/logo_9581a5e6-925f-4c66-ab2c-708dac0606f5.png?v=1775011264" alt="" class="fh-logo-icon"></span>' +
        '<h3 class="fh-empty__title">Non segui ancora nessuna ricerca</h3>' +
        '<p class="fh-empty__text">Esplora i giochi cercati dalla community e diventa Frogger!</p>' +
      '</div>';
    }
    if (state.query || state.filterStatus !== 'all') {
      return '<div class="fh-empty">' +
        '<span class="fh-empty__icon">&#x1F50D;</span>' +
        '<h3 class="fh-empty__title">Nessun risultato</h3>' +
        '<p class="fh-empty__text">Prova a cambiare i filtri o cerca qualcos\'altro</p>' +
      '</div>';
    }
    return '<div class="fh-empty">' +
      '<span class="fh-empty__icon">&#x1F3AF;</span>' +
      '<h3 class="fh-empty__title">' + t('vuoto_titolo', 'Nessuna ricerca attiva') + '</h3>' +
      '<p class="fh-empty__text">' + t('vuoto_testo', 'Sii il primo! Proponi un gioco che stai cercando') + '</p>' +
    '</div>';
  }

  // ── VIEW SWITCH ─────────────────────────────────────────
  function setView(view) {
    state.view = view;
    document.querySelectorAll('.fh-nav__btn').forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-view') === view);
    });
    var trendingEl = document.getElementById('fhTrending');
    if (trendingEl) trendingEl.style.display = view === 'browse' ? '' : 'none';
    renderGrid();
  }

  // ── FOLLOW / UNFOLLOW ───────────────────────────────────
  // #2A — segui resumibile: ricorda l'intento (localStorage), manda al login, e al rientro
  // completa la segui in automatico (nessun vicolo cieco per gli anonimi). Il ripristino e'
  // guidato dal localStorage, non dall'URL — così funziona con i nuovi account Shopify
  // (/customer_authentication/redirect) qualunque return_url usino: basta rientrare loggati.
  function savePendingFollow(slug) {
    try { localStorage.setItem('fh_pending_follow', JSON.stringify({ slug: slug, at: Date.now() })); } catch (e) {}
  }
  function resumePendingFollow() {
    if (!customerId) return;
    var raw;
    try { raw = localStorage.getItem('fh_pending_follow'); } catch (e) { return; }
    if (!raw) return;
    try { localStorage.removeItem('fh_pending_follow'); } catch (e) {}
    var p; try { p = JSON.parse(raw); } catch (e) { return; }
    if (!p || !p.slug) return;
    if (!p.at || (Date.now() - p.at) > 30 * 60 * 1000) return; // scade dopo 30 min
    if (state.myHuntSlugs && state.myHuntSlugs.indexOf(p.slug) !== -1) return; // già seguo
    // riapre il flusso segui (scelta lingua) per la hunt in sospeso
    setTimeout(function () { handleFollowClick(p.slug); }, 700);
  }

  function handleFollowClick(slug) {
    if (!customerId) { savePendingFollow(slug); window.location.href = loginUrl; return; }

    var isFollowing = state.myHuntSlugs.indexOf(slug) !== -1;
    if (isFollowing) {
      unfollowHunt(slug);
    } else {
      // Show telegram prompt
      state.pendingFollowSlug = slug;
      document.getElementById('fhFollowTelegram').value = '';
      $telegramModal.classList.add('open');
    }
  }

  function confirmFollow(slug, telegram, languages) {
    closeTelegramModal();
    if (!slug) return;

    // Normalizza: accetta array (nuovo) o stringa (legacy)
    var langArray = Array.isArray(languages) ? languages : (languages ? [languages] : ['IT']);

    // Optimistic UI
    state.myHuntSlugs.push(slug);
    var hunt = state.hunts.find(function (h) { return h.slug === slug; });
    if (hunt) hunt.froggerCount = (hunt.froggerCount || 0) + 1;
    renderGrid();
    animateFroggerButton(slug);

    apiPost('/api/hunts', {
      action: 'follow',
      customerId: String(customerId),
      customerName: customerName,
      slug: slug,
      telegram: telegram,
      languages: langArray,
      language: langArray[0]
    }).then(function (res) {
      if (res.error) {
        // Rollback
        state.myHuntSlugs = state.myHuntSlugs.filter(function (s) { return s !== slug; });
        if (hunt) hunt.froggerCount = Math.max(0, (hunt.froggerCount || 0) - 1);
        renderGrid();
        showToast(res.error, 'error');
      } else {
        showToast('Sei diventato Frogger! Ti avviseremo quando troviamo il gioco', 'success');
        updateStats();
      }
    }).catch(function () {
      state.myHuntSlugs = state.myHuntSlugs.filter(function (s) { return s !== slug; });
      if (hunt) hunt.froggerCount = Math.max(0, (hunt.froggerCount || 0) - 1);
      renderGrid();
      showToast('Errore di connessione', 'error');
    });
  }

  // Ritiro della propria proposta. Regole (stesse del worker, qui solo per non
  // mostrare un bottone che verrebbe rifiutato): solo il proponente, e solo finche'
  // la hunt non e' stata annunciata — da 'found' in poi Telegram e mail sono gia'
  // partiti, quindi resta e si puo' solo smettere di seguirla.
  function canWithdraw(hunt) {
    if (!customerId || !hunt) return false;
    var pid = (hunt.proposedBy && hunt.proposedBy.customerId) || hunt.proposedByCustomerId;
    if (!pid || String(pid) !== String(customerId)) return false;
    if (hunt.purchasableSince) return false;
    return hunt.status === 'proposed' || hunt.status === 'searching';
  }

  function withdrawHunt(hunt) {
    var slug = hunt && hunt.slug;
    if (!slug) return;
    // Se altri la seguono la hunt NON sparisce: lo diciamo prima, non dopo.
    var others = Math.max(0, (hunt.froggerCount || 1) - 1);
    var msg = others > 0
      ? others + ' ' + t('ritira_altri', 'altri Frogger stanno aspettando questo gioco. La ricerca resta aperta e passa a loro: tu smetti di seguirla. Procedo?')
      : t('ritira_solo', 'Vuoi ritirare la tua proposta? Sparisce dalla pagina.');
    if (!confirm(msg)) return;

    apiPost('/api/hunts', {
      action: 'withdraw',
      customerId: String(customerId),
      customerName: customerName,
      slug: slug
    }).then(function (res) {
      if (!res || res.error) {
        showToast((res && res.error) || 'Errore', 'error');
        return;
      }
      state.myHuntSlugs = state.myHuntSlugs.filter(function (x) { return x !== slug; });
      if (res.deleted) {
        state.hunts = state.hunts.filter(function (h) { return h.slug !== slug; });
        showToast(t('ritira_ok', 'Proposta ritirata'), 'success');
      } else {
        var h = state.hunts.find(function (x) { return x.slug === slug; });
        if (h) {
          h.froggerCount = res.froggerCount;
          h.proposerName = res.newProposer;
          h.proposedByCustomerId = null;
        }
        showToast(t('ritira_ok_altri', 'Sei uscito. La ricerca resta aperta per gli altri Frogger.'), 'success');
      }
      closeDetailModal();
      renderGrid();
      updateStats();
    }).catch(function () {
      showToast('Errore di connessione', 'error');
    });
  }

  function unfollowHunt(slug) {
    // Optimistic UI
    state.myHuntSlugs = state.myHuntSlugs.filter(function (s) { return s !== slug; });
    var hunt = state.hunts.find(function (h) { return h.slug === slug; });
    if (hunt) hunt.froggerCount = Math.max(0, (hunt.froggerCount || 0) - 1);
    renderGrid();

    apiPost('/api/hunts', {
      action: 'unfollow',
      customerId: String(customerId),
      slug: slug
    }).then(function (res) {
      if (res.error) {
        state.myHuntSlugs.push(slug);
        if (hunt) hunt.froggerCount = (hunt.froggerCount || 0) + 1;
        renderGrid();
        showToast(res.error, 'error');
      } else {
        showToast('Non segui piu questa ricerca', 'success');
        updateStats();
      }
    });
  }

  function animateFroggerButton(slug) {
    var btn = $grid.querySelector('.fh-card__frogger-cta[data-slug="' + slug + '"]');
    if (btn) {
      btn.classList.add('fh-pop');
      setTimeout(function () { btn.classList.remove('fh-pop'); }, 350);
    }
  }

  // ── DETAIL MODAL ────────────────────────────────────────
  function openDetailModal(slug) {
    // Apertura istantanea: usa i dati che già ho in state.hunts
    var preview = state.hunts.find(function (h) { return h.slug === slug; });
    if (preview) {
      $detailTitle.textContent = preview.name;
      $detailBody.innerHTML = renderDetail(preview) +
        '<div class="fh-detail__loading-extra">Carico cronologia e commenti...</div>';
      state.selectedHunt = preview;
    } else {
      $detailTitle.textContent = 'Caricamento...';
      $detailBody.innerHTML = renderDetailSkeleton();
    }
    $detailModal.classList.add('open');

    // Update URL
    var url = new URL(window.location);
    url.searchParams.set('hunt', slug);
    history.pushState({}, '', url);

    Promise.all([
      apiGet('/api/hunts/' + slug),
      apiGet('/api/comments/' + slug)
    ]).then(function (results) {
      var hunt = results[0];
      var comments = results[1] || [];
      state.selectedHunt = hunt;
      $detailTitle.textContent = hunt.name;
      $detailBody.innerHTML = renderDetail(hunt) + renderComments(comments, slug);
      hydrateFoundStock(hunt);

      // Bind follow button
      var followBtn = document.getElementById('fhDetailFollowBtn');
      if (followBtn) {
        followBtn.addEventListener('click', function () {
          handleFollowClick(hunt.slug);
          setTimeout(function () {
            var updated = state.hunts.find(function (h) { return h.slug === hunt.slug; });
            if (updated) hunt.froggerCount = updated.froggerCount;
            $detailBody.innerHTML = renderDetail(hunt) + renderComments(comments, slug);
            hydrateFoundStock(hunt);
          }, 300);
        });
      }

      // Bind comment submit
      var commentBtn = document.getElementById('fhCommentSubmit');
      if (commentBtn) {
        commentBtn.addEventListener('click', function () {
          submitComment(slug, comments);
        });
      }
      var commentInput = document.getElementById('fhCommentInput');
      if (commentInput) {
        commentInput.addEventListener('keydown', function (e) {
          // Enter = new line, not submit
        });
      }
      // Bind share
      var shareBtn = document.getElementById('fhShareBtn');
      if (shareBtn) {
        shareBtn.addEventListener('click', function () { handleShare(slug, hunt.name); });
      }
      // Bind ritiro proposta
      var withdrawBtn = document.getElementById('fhWithdrawBtn');
      if (withdrawBtn) {
        withdrawBtn.addEventListener('click', function () { withdrawHunt(hunt); });
      }
      // Bind reopen
      var reopenBtn = document.getElementById('fhReopenBtn');
      if (reopenBtn) {
        reopenBtn.addEventListener('click', function () { handleReopenClick(slug); });
      }
      // Bind close bottom
      var closeBottomBtn = document.getElementById('fhDetailCloseBottom');
      if (closeBottomBtn) {
        closeBottomBtn.addEventListener('click', closeDetailModal);
      }
    }).catch(function (err) {
      // 404 = hunt eliminata dalla dashboard (record soft-deleted, link vecchio da
      // Telegram/mail o lista aperta da prima). Dirlo, invece di un errore generico.
      var gone = err && /API error 404/.test(String(err.message || ''));
      $detailBody.innerHTML = '<div class="fh-empty"><p>' + (gone
        ? t('hunt_rimossa', 'Questa ricerca è stata rimossa dal sito.')
        : 'Errore nel caricamento') + '</p></div>';
      if (gone) {
        $detailTitle.textContent = (preview && preview.name) || t('hunt_rimossa_titolo', 'Ricerca non disponibile');
        state.hunts = state.hunts.filter(function (h) { return h.slug !== slug; });
      }
    });
  }

  function closeDetailModal() {
    $detailModal.classList.remove('open');
    state.selectedHunt = null;
    var url = new URL(window.location);
    url.searchParams.delete('hunt');
    history.pushState({}, '', url);
  }

  function renderDetailSkeleton(){
    return '<div class="fhd2-skel">'
      + '<div class="fhd2-skel__cover"></div>'
      + '<div class="fhd2-skel__line fhd2-skel__line--lg"></div>'
      + '<div class="fhd2-skel__line fhd2-skel__line--md"></div>'
      + '<div class="fhd2-skel__row">'
        + '<div class="fhd2-skel__chip"></div><div class="fhd2-skel__chip"></div><div class="fhd2-skel__chip"></div>'
      + '</div>'
      + '<div class="fhd2-skel__line fhd2-skel__line--md"></div>'
      + '<div class="fhd2-skel__line fhd2-skel__line--sm"></div>'
      + '</div>';
  }

  // #1a — helper stock live sul momento Trovato
  function fhShopHandle(url) {
    var m = String(url || '').match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1] : null;
  }
  function fhSoldOutHtml(isFollowing) {
    var cta = isFollowing
      ? '<div class="fhd2__soldout-note">Sei gia\' tra chi verra\' avvisato appena torna.</div>'
      : '<button type="button" class="fhd2__notify-btn" id="fhNotifyRestock"><span aria-hidden="true">&#x1F514;</span> Avvisami quando torna</button>';
    return '<div class="fhd2__shop fhd2__shop--paused"><span aria-hidden="true">&#x1F553;</span><span>Momentaneamente esaurito</span></div>' + cta;
  }
  // Legge lo stock reale del prodotto al momento dell'apertura e aggiorna il blocco acquisto.
  // available=false o qty=0 -> stato esaurito; qty<=5 -> "ne restano N" (onesto: solo se il conteggio è affidabile).
  function hydrateFoundStock(hunt) {
    var blocks = $detailBody.querySelectorAll('[data-shop-handle]');
    Array.prototype.forEach.call(blocks, function (block) {
      var handle = block.getAttribute('data-shop-handle');
      if (!handle) return;
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var available = !!p.available;
          var qty = null, hasNum = false, sum = 0;
          if (Array.isArray(p.variants)) {
            p.variants.forEach(function (v) {
              if (typeof v.inventory_quantity === 'number') { sum += Math.max(0, v.inventory_quantity); hasNum = true; }
            });
            if (hasNum) qty = sum;
          }
          var following = block.getAttribute('data-following') === '1';
          if (!available || qty === 0) {
            block.innerHTML = fhSoldOutHtml(following);
            var btn = document.getElementById('fhNotifyRestock');
            if (btn) btn.addEventListener('click', function () { handleFollowClick(hunt.slug); });
            return;
          }
          var lineEl = block.querySelector('[data-stockline]');
          if (lineEl && qty !== null && qty <= 5) {
            lineEl.hidden = false;
            lineEl.className = 'fhd2__stockline fhd2__stockline--low';
            lineEl.innerHTML = '<span aria-hidden="true">&#x1F525;</span> Ne restano <strong>' + qty + '</strong>';
          }
        })
        .catch(function () {});
    });
    // #1b — countdown finestra di vantaggio
    var advEls = $detailBody.querySelectorAll('[data-adv-deadline]');
    Array.prototype.forEach.call(advEls, function (el) {
      var deadline = parseInt(el.getAttribute('data-adv-deadline'), 10) || 0;
      var hEl = el.querySelector('[data-adv-h]'), mEl = el.querySelector('[data-adv-m]'), sEl = el.querySelector('[data-adv-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        if (!document.body.contains(el)) { clearInterval(el._advTimer); return; }
        var diff = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        if (diff <= 0) { el.style.display = 'none'; clearInterval(el._advTimer); return; }
        var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
        if (hEl) hEl.textContent = h;
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      tick();
      el._advTimer = setInterval(tick, 1000);
    });
  }

  function renderDetail(hunt) {
    var isFollowing = state.myHuntSlugs.indexOf(hunt.slug) !== -1;
    var img = hunt.image || hunt.thumbnail || '';
    var imgSrc = img ? fullImageUrl(img) : '';
    var statusText = statusLabel(hunt.status);

    var metaChips = [];
    if (hunt.year) metaChips.push({ icon: '&#x1F4C5;', value: hunt.year, label: 'Anno' });
    if (hunt.minPlayers && hunt.maxPlayers) metaChips.push({ icon: '&#x1F465;', value: hunt.minPlayers + '-' + hunt.maxPlayers, label: 'Giocatori' });
    if (hunt.playingTime) metaChips.push({ icon: '&#x23F1;', value: hunt.playingTime + '\'', label: 'Durata' });
    if (hunt.weight) metaChips.push({ icon: '&#x1F9E0;', value: hunt.weight.toFixed(1), label: 'Complessita' });
    if (hunt.bggRating) metaChips.push({ icon: '&#x2B50;', value: hunt.bggRating.toFixed(1), label: 'Voto BGG' });
    if (hunt.bggRank) metaChips.push({ icon: '&#x1F3C6;', value: '#' + hunt.bggRank, label: 'Rank BGG' });

    var html = '<div class="fhd2">';

    // HERO con cover + info side by side
    html += '<div class="fhd2__hero">';
    if (imgSrc) {
      html += '<div class="fhd2__cover-wrap"><img class="fhd2__cover" src="' + escHtml(imgSrc) + '" alt="' + escHtml(hunt.name) + '" loading="eager"></div>';
    }
    html += '<div class="fhd2__head">';
    html += '<div class="fhd2__pills">';
    html += '<span class="fhd2__status fhd2__status--' + hunt.status + '">' + statusText + '</span>';
    // Machine of War: difficolta' + tipo ricerca
    var DIFF_D = {easy:['🟢 Facile','#d1fae5','#065f46'],medium:['🟡 Media','#fef3c7','#92400e'],hard:['🟠 Difficile','#fed7aa','#9a3412'],very_hard:['🔴 Molto Difficile','#fee2e2','#991b1b'],impossible:['💎 Rarissimo','#1f2937','#f4c430']};
    var TYPE_D = {kickstarter:['🚀 Kickstarter','#ede9fe','#5b21b6'],gamefound:['🎯 Gamefound','#ede9fe','#5b21b6'],reprint:['🔄 Ristampa','#dbeafe','#1e40af'],preorder:['🎁 Preorder','#dbeafe','#1e40af'],restock:['📥 Restock','#f3e8ff','#6b21a8']};
    if (hunt.difficulty && DIFF_D[hunt.difficulty]) {
      var d = DIFF_D[hunt.difficulty];
      html += '<span class="fhd2__pill" style="background:'+d[1]+';color:'+d[2]+'" title="Difficolta\' di reperimento stimata">'+d[0]+'</span>';
    }
    if (hunt.proposalType && TYPE_D[hunt.proposalType]) {
      // NON chiamarla "t": con var viene sollevata a inizio funzione e nasconde t() (le
      // traduzioni) in TUTTA renderDetail → "t is not a function" e la scheda non si apre.
      // Succedeva a ogni hunt comprabile (t('acquista_ora'), dal 7 set) e alle proprie
      // proposte (t('ritira')).
      var tipo = TYPE_D[hunt.proposalType];
      html += '<span class="fhd2__pill" style="background:'+tipo[1]+';color:'+tipo[2]+'">'+tipo[0]+'</span>';
    }
    html += '</div>';
    html += '<h2 class="fhd2__name">' + escHtml(hunt.name) + '</h2>';
    // Banner esplicativo difficoltà — dice al cliente cosa aspettarsi (onesto, no false promesse)
    var DIFF_INFO = {
      easy:      { icon:'🟢', title:'Facile da recuperare', text:'Editore ancora attivo, canali aperti. Dovremmo trovarlo in tempi ragionevoli.', bg:'#F0FDF4', border:'#10B981', color:'#065F46' },
      medium:    { icon:'🟡', title:'Impegno medio',        text:'Serve un po\' di ricerca: distributore giusto o piccolo lotto. Ci vorrà qualche settimana.', bg:'#FEFCE8', border:'#EAB308', color:'#78350F' },
      hard:      { icon:'🟠', title:'Difficile',            text:'Non è a catalogo dei distributori standard. Cerchiamo canali paralleli — tempi lunghi, non promettiamo.', bg:'#FFF7ED', border:'#F97316', color:'#7C2D12' },
      very_hard: { icon:'🔴', title:'Molto difficile',      text:'Fuori catalogo o quasi. Tentiamo attivamente ma le speranze sono poche. Meglio saperlo prima.', bg:'#FEF2F2', border:'#DC2626', color:'#7F1D1D' },
      impossible:{ icon:'💎', title:'Rarissimo',            text:'Solo mercato collezionismo. Prezzi imprevedibili, disponibilità sporadica. Segui per essere avvisato se salta fuori.', bg:'#111827', border:'#F4C430', color:'#F4C430' }
    };
    if (hunt.difficulty && DIFF_INFO[hunt.difficulty]) {
      var _di = DIFF_INFO[hunt.difficulty];
      html += '<div class="fhd2__diffbanner" style="background:'+_di.bg+';border-left:4px solid '+_di.border+';color:'+_di.color+'">'+
        '<div class="fhd2__diffbanner-head"><span class="fhd2__diffbanner-icon">'+_di.icon+'</span><b>'+_di.title+'</b></div>'+
        '<p class="fhd2__diffbanner-text">'+escHtml(_di.text)+'</p>'+
      '</div>';
    }
    if (hunt.designers && hunt.designers.length) {
      html += '<p class="fhd2__designers">di ' + hunt.designers.map(escHtml).join(', ') + '</p>';
    }
    // Machine of War: firma proposer — sempre visibile se abbiamo il nome
    // (badge livello solo se guadagnato)
    if (hunt.proposerName) {
      var badge = (hunt.proposerLevel && hunt.proposerLevelLabel)
        ? ' <span class="fhd2__proposer-badge fhd2__proposer-badge--' + hunt.proposerLevel + '">' + hunt.proposerLevelLabel + '</span>'
        : '';
      html += '<p class="fhd2__proposer">Proposto da <strong>' + escHtml(hunt.proposerName) + '</strong>' + badge + '</p>';
    }
    if (hunt.statusNote) {
      html += '<p class="fhd2__note">' + escHtml(hunt.statusNote) + '</p>';
    }
    html += '</div></div>';

    // META CHIPS riga compatta
    if (metaChips.length) {
      html += '<div class="fhd2__chips">';
      metaChips.forEach(function (c) {
        html += '<div class="fhd2__chip"><span class="fhd2__chip-icon">' + c.icon + '</span><span class="fhd2__chip-val">' + c.value + '</span><span class="fhd2__chip-lab">' + c.label + '</span></div>';
      });
      html += '</div>';
    }

    // CATEGORIE (sottili, pill)
    if (hunt.categories && hunt.categories.length) {
      html += '<div class="fhd2__cats">';
      hunt.categories.slice(0, 6).forEach(function (c) {
        html += '<span class="fhd2__cat">' + escHtml(c) + '</span>';
      });
      html += '</div>';
    }

    // SHOPIFY LINK — #1a momento Trovato: prova sociale (froggerCount) + stock LIVE
    // all'apertura (via /products/{handle}.js), così "esaurito"/"ne restano N" è sempre
    // vero all'istante e non dipende dal cron giornaliero.
    if (hunt.shopifyProductUrl && hunt.status === 'found' && isValidShopUrl(hunt.shopifyProductUrl)) {
      // #1b — finestra di vantaggio: countdown all'annuncio pubblico (solo se ancora aperta)
      var _fpa = hunt.foundPublicAt ? Date.parse(hunt.foundPublicAt) : 0;
      if (_fpa && _fpa > Date.now()) {
        html += '<div class="fhd2__adv" data-adv-deadline="' + _fpa + '">'
          + '<div class="fhd2__adv-head"><span aria-hidden="true">&#x1F512;</span> Riservato a chi lo cercava</div>'
          + '<div class="fhd2__adv-sub">Hai un vantaggio: diventa pubblico tra</div>'
          + '<div class="fhd2__adv-clock"><b data-adv-h>--</b><i>h</i> <b data-adv-m>--</b><i>m</i> <b data-adv-s>--</b><i>s</i></div>'
          + '</div>';
      }
      var _waiting = hunt.froggerCount || 0;
      // "Eri 1 di N in attesa" — solo se la community era reale (>=3), altrimenti niente
      if (_waiting >= 3) {
        html += '<div class="fhd2__waiting"><span aria-hidden="true">&#x1F465;</span> Eri <strong>1 di ' + _waiting + '</strong> in attesa di questo gioco</div>';
      }
      // Gia' preso: lo diciamo, ma il bottone resta (si ricompra per regalo)
      if (isPurchasedByMe(hunt.slug)) {
        var _pat = purchasedAtByMe(hunt.slug);
        html += '<div class="fhd2__got"><span aria-hidden="true">&#x2714;</span> ' + t('preso_il', 'L\'hai gia\' preso')
          + (_pat ? ' <strong>' + escHtml(formatDate(_pat)) + '</strong>' : '') + '</div>';
      }
      var _handle = fhShopHandle(hunt.shopifyProductUrl);
      html += '<div class="fhd2__buy" data-shop-handle="' + escHtml(_handle || '') + '" data-following="' + (isFollowing ? '1' : '0') + '">';
      if (hunt.purchasablePaused) {
        html += fhSoldOutHtml(isFollowing);
      } else {
        html += '<a class="fhd2__shop" href="' + escHtml(hunt.shopifyProductUrl) + '">'
          + '<span>&#x1F6D2;</span><span>' + t('acquista_ora', 'Acquista ora su FroGames') + '</span><span class="fhd2__shop-arrow">&rarr;</span>'
          + '</a>'
          + '<div class="fhd2__stockline" data-stockline hidden></div>';
      }
      html += '</div>';
    } else if (hunt.status === 'found' && hunt.shopifyProductUrl && !isValidShopUrl(hunt.shopifyProductUrl)) {
      // Placeholder morbido: il link è stato salvato ma non è valido (bug dati)
      html += '<div class="fhd2__shop" style="background:#f5f5f5;color:#666;cursor:default">'
        + '<span>&#x2139;</span><span>Trovato &mdash; a breve disponibile</span>'
        + '</div>';
    }

    // DESCRIZIONE (collapsible)
    if (hunt.description) {
      html += '<details class="fhd2__desc-toggle">'
        + '<summary>&#x1F4D6; Leggi la descrizione</summary>'
        + '<div class="fhd2__desc">' + escHtml(hunt.description) + '</div>'
      + '</details>';
    }

    // AZIONI SECONDARIE (link BGG, campagna KS/GF, condividi)
    html += '<div class="fhd2__actions-row">';
    if (hunt.bggUrl) {
      html += '<a class="fhd2__action" href="' + escHtml(hunt.bggUrl) + '" target="_blank" rel="noopener">&#x1F3B2; BoardGameGeek</a>';
    }
    // Machine of War: link campagna KS/GF (visibile solo se il cliente l'ha fornito)
    if (hunt.campaignUrl && isValidShopUrl(hunt.campaignUrl)) {
      var campIcon = hunt.proposalType === 'kickstarter' ? '&#x1F680;' : (hunt.proposalType === 'gamefound' ? '&#x1F3AF;' : '&#x1F517;');
      var campLabel = hunt.proposalType === 'kickstarter' ? 'Vai al Kickstarter' : (hunt.proposalType === 'gamefound' ? 'Vai al Gamefound' : 'Campagna');
      html += '<a class="fhd2__action" href="' + escHtml(hunt.campaignUrl) + '" target="_blank" rel="noopener" style="background:linear-gradient(135deg,#F59E0B,#EF4444);color:#fff;border-color:transparent;font-weight:800">' + campIcon + ' ' + campLabel + '</a>';
    }
    html += '<button class="fhd2__action" id="fhShareBtn" data-slug="' + hunt.slug + '" data-name="' + escHtml(hunt.name) + '">&#x1F517; Condividi</button>';
    // Ritira: solo a chi l'ha proposta, solo prima dell'annuncio
    if (canWithdraw(hunt)) {
      html += '<button class="fhd2__action fhd2__action--withdraw" id="fhWithdrawBtn">&#x1F5D1; ' + t('ritira', 'Ritira la proposta') + '</button>';
    }
    html += '</div>';

    // CRONOLOGIA timeline elegante
    if (hunt.statusHistory && hunt.statusHistory.length) {
      html += '<div class="fhd2__section">';
      html += '<h3 class="fhd2__section-title">Cronologia</h3>';
      html += '<div class="fhd2__timeline">';
      var currentNote = (hunt.statusNote || '').trim();
      hunt.statusHistory.slice().reverse().forEach(function (entry, idx) {
        // Non duplicare la nota gia\' mostrata nell\'hero (corrente)
        var entryNote = (entry.note || '').trim();
        var showNote = entryNote && !(idx === 0 && entryNote === currentNote);
        html += '<div class="fhd2__tline">'
          + '<div class="fhd2__tdot fhd2__tdot--' + entry.status + '"></div>'
          + '<div class="fhd2__tcontent">'
            + '<div class="fhd2__tstatus">' + statusLabel(entry.status) + '</div>'
            + (showNote ? '<div class="fhd2__tnote">' + escHtml(entry.note) + '</div>' : '')
            + '<div class="fhd2__tdate">' + formatDate(entry.at) + '</div>'
          + '</div>'
        + '</div>';
      });
      html += '</div></div>';
    }

    // STICKY CTA FOLLOW + reopen
    html += '<div class="fhd2__sticky">';
    html += '<div class="fhd2__follow-count">'
      + '<span class="fhd2__follow-icon"><img src="https://cdn.shopify.com/s/files/1/0887/8905/7863/files/logo_9581a5e6-925f-4c66-ab2c-708dac0606f5.png?v=1775011264" alt="" class="fh-logo-icon"></span>'
      + '<strong>' + (hunt.froggerCount || 0) + '</strong>'
      + '<span>Frogger' + (hunt.froggerCount !== 1 ? 's' : '') + '</span>'
    + '</div>';

    if (customerId) {
      // Su una hunt chiusa "Segui gia'" sembra uno stato, non un'azione: chi vuole
      // toglierla dalla propria lista non capiva come. Stessa azione (unfollow), parole giuste.
      var isClosedHunt = ['found', 'out_of_print', 'unavailable'].indexOf(hunt.status) !== -1;
      var btnClass = 'fhd2__follow-btn' + (isFollowing ? (isClosedHunt ? ' is-following is-remove' : ' is-following') : '');
      var btnText = isFollowing
        ? (isClosedHunt ? '&#x2715; ' + t('togli_lista', 'Togli dalla mia lista') : '&#x2714; Segui già')
        : '<img src="https://cdn.shopify.com/s/files/1/0887/8905/7863/files/logo_9581a5e6-925f-4c66-ab2c-708dac0606f5.png?v=1775011264" alt="" class="fh-logo-icon"> Diventa Frogger';
      html += '<button class="' + btnClass + '" id="fhDetailFollowBtn">' + btnText + '</button>';
    } else {
      html += '<button class="fhd2__follow-btn" id="fhDetailFollowBtn">Accedi e seguila</button>';
      html += '<p class="fhd2__follow-hint">Ti riportiamo qui e la segui in automatico.</p>';
    }
    html += '</div>';

    html += renderReopenBar(hunt);

    html += '</div>'; // close .fhd2
    return html;
  }

  function metaItem(value, label) {
    return '<div class="fh-detail__meta-item">' +
      '<span class="fh-detail__meta-value">' + value + '</span>' +
      '<span class="fh-detail__meta-label">' + label + '</span>' +
    '</div>';
  }

  // ── PROPOSE MODAL ───────────────────────────────────────
  function openProposeModal() {
    $bggInput.value = '';
    $bggPreview.innerHTML = '';
    var searchEl = document.getElementById('fhBggSearchResults');
    if (searchEl) { searchEl.hidden = true; searchEl.innerHTML = ''; }
    document.getElementById('fhTelegram').value = '';
    $proposeError.classList.remove('show');
    state.bggData = null;
    // Machine of War: reset chip lingua (IT default) + chip tipo (retail default) + campagna vuota
    var pl = document.getElementById('fhProposeLangChips');
    if (pl) {
      pl.querySelectorAll('.fh-lang-chip').forEach(function(c){ c.classList.remove('is-active'); });
      var defLang = pl.querySelector('[data-lang="IT"]');
      if (defLang) defLang.classList.add('is-active');
    }
    var pt = document.getElementById('fhProposeTypeChips');
    if (pt) {
      pt.querySelectorAll('.fh-lang-chip').forEach(function(c){ c.classList.remove('is-active'); });
      var defType = pt.querySelector('[data-ptype="retail"]');
      if (defType) defType.classList.add('is-active');
      pt.setAttribute('data-selected', 'retail');
    }
    var cu = document.getElementById('fhCampaignUrl');
    if (cu) { cu.value = ''; cu.style.display = 'none'; }
    // Reset conferma campagna + box + warning URL
    var cb = document.getElementById('fhCampaignConfirmBox');
    if (cb) cb.style.display = 'none';
    var cc = document.getElementById('fhCampaignConfirm');
    if (cc) cc.checked = false;
    var cw = document.getElementById('fhCampaignUrlWarn');
    if (cw) cw.style.display = 'none';
    if (typeof window.__fhUpdateProposeSubmit === 'function') window.__fhUpdateProposeSubmit();
    $proposeModal.classList.add('open');
    setTimeout(function () { $bggInput.focus(); }, 100);
  }

  function closeProposeModal() {
    $proposeModal.classList.remove('open');
  }

  function closeTelegramModal() {
    $telegramModal.classList.remove('open');
    state.pendingFollowSlug = null;
  }

  // Machine of War: ricerca visiva BGG (thumbnails) — chiamata quando l'utente scrive un nome
  function fetchBggSearchResults(query) {
    var searchEl = document.getElementById('fhBggSearchResults');
    if (!searchEl) return;
    searchEl.hidden = false;
    searchEl.innerHTML = '<div class="fh-bgg-loading">Cerco su BoardGameGeek...</div>';

    apiGet('/api/bgg-search?q=' + encodeURIComponent(query)).then(function (data) {
      var results = (data && data.results) || [];
      if (!results.length) {
        searchEl.innerHTML = '<div class="fh-bgg-search__empty">Nessun risultato per "<b>' + escHtml(query) + '</b>". Prova con un altro nome o incolla il link BGG.</div>';
        return;
      }
      // Griglia risultati (max 12)
      var html = '<div class="fh-bgg-search__grid">';
      results.slice(0, 12).forEach(function (r) {
        var img = r.img ? 'https://wsrv.nl/?url=' + encodeURIComponent(r.img) + '&w=140&h=140&fit=cover&output=webp&q=82' : '';
        var akaLine = r.aka ? '<div class="fh-bgg-search__aka">🇮🇹 ' + escHtml(r.aka) + '</div>' : '';
        html += '<button type="button" class="fh-bgg-search__item" data-bgg-id="' + r.bggId + '">' +
          (img
            ? '<img class="fh-bgg-search__thumb" src="' + img + '" alt="" loading="lazy">'
            : '<div class="fh-bgg-search__thumb fh-bgg-search__thumb--ph">🎲</div>') +
          '<div class="fh-bgg-search__info">' +
            '<div class="fh-bgg-search__name">' + escHtml(r.name) + '</div>' +
            akaLine +
            (r.year ? '<div class="fh-bgg-search__year">' + r.year + '</div>' : '') +
          '</div>' +
        '</button>';
      });
      html += '</div>';
      searchEl.innerHTML = html;

      // Click handler sui risultati
      searchEl.querySelectorAll('[data-bgg-id]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var bggId = btn.getAttribute('data-bgg-id');
          selectBggResult(bggId);
        });
      });
    }).catch(function () {
      searchEl.innerHTML = '<div class="fh-bgg-search__empty" style="color:#D64545">Errore nella ricerca. Riprova o incolla direttamente il link BGG.</div>';
    });
  }

  // Selezione risultato ricerca visiva → preview singolo (bggData impostato)
  function selectBggResult(bggId) {
    var searchEl = document.getElementById('fhBggSearchResults');
    if (searchEl) searchEl.hidden = true;
    var bggUrl = 'https://boardgamegeek.com/boardgame/' + bggId;
    $bggInput.value = bggUrl;
    fetchBggPreview(bggUrl);
  }

  function fetchBggPreview(url) {
    $bggPreview.innerHTML = '<div class="fh-bgg-loading">Cerco su BoardGameGeek...</div>';

    apiGet('/api/bgg?url=' + encodeURIComponent(url)).then(function (data) {
      if (data.error) {
        $bggPreview.innerHTML = '<p style="color:#D64545;font-size:.85rem;padding:12px">' + escHtml(data.error) + '</p>';
        state.bggData = null;
        return;
      }
      state.bggData = data;
      $bggPreview.innerHTML = '<div class="fh-bgg-preview">' +
        (data.thumbnail ? '<img class="fh-bgg-preview__image" src="' + escHtml(data.thumbnail) + '" alt="">' : '') +
        '<div class="fh-bgg-preview__info">' +
          '<h4>' + escHtml(data.name) + '</h4>' +
          (data.year ? '<p>' + data.year + ' &bull; ' + data.minPlayers + '-' + data.maxPlayers + ' giocatori &bull; ' + data.playingTime + ' min</p>' : '') +
          (data.categories ? '<p>' + data.categories.slice(0, 3).join(', ') + '</p>' : '') +
          '<p class="fh-bgg-preview__check">&#x2705; Dati trovati!</p>' +
        '</div>' +
      '</div>';
    }).catch(function () {
      $bggPreview.innerHTML = '<p style="color:#D64545;font-size:.85rem;padding:12px">Errore nel contattare BGG</p>';
      state.bggData = null;
    });
  }

  function submitProposal() {
    var submitBtn = document.getElementById('fhProposeSubmit');
    var telegram = document.getElementById('fhTelegram').value.trim();

    if (!state.bggData) {
      showProposeError('Inserisci un link BGG valido per proporre un gioco');
      return;
    }

    // Preferisci le lingue del modal PROPONI (se esistente), altrimenti fallback al follow
    var langs = (typeof window.__fhGetProposeLangs === 'function')
      ? window.__fhGetProposeLangs()
      : (typeof window.__fhGetLangs === 'function' ? window.__fhGetLangs() : ['IT']);
    var ptype = (typeof window.__fhGetPtype === 'function') ? window.__fhGetPtype() : 'retail';
    var campUrl = (typeof window.__fhGetCampaignUrl === 'function') ? window.__fhGetCampaignUrl() : '';

    // Machine of War: se KS/GF, richiedi conferma "campagna attiva" (backup del bottone disabled)
    if ((ptype === 'kickstarter' || ptype === 'gamefound')) {
      var confirmed = (typeof window.__fhIsCampaignConfirmed === 'function') ? window.__fhIsCampaignConfirmed() : true;
      if (!confirmed) {
        showProposeError('Devi confermare che la campagna e\' attualmente attiva prima di proseguire.');
        return;
      }
    }

    var body = {
      action: 'propose',
      customerId: String(customerId),
      customerName: customerName,
      telegram: telegram,
      bggUrl: state.bggData.bggUrl,
      // Mandiamo anche quello che l'utente VEDE gia' nel riquadro "Dati trovati": se BGG
      // non risponde al worker, la hunt nasce lo stesso con nome e copertina giusti.
      bggId: state.bggData.bggId || null,
      name: state.bggData.name || '',
      image: state.bggData.image || '',
      thumbnail: state.bggData.thumbnail || state.bggData.img || '',
      year: state.bggData.year || 0,
      minPlayers: state.bggData.minPlayers || 0,
      maxPlayers: state.bggData.maxPlayers || 0,
      playingTime: state.bggData.playingTime || 0,
      languages: langs,
      language: langs[0],
      proposalType: ptype,
      campaignUrl: campUrl || null
    };

    submitBtn.disabled = true;
    submitBtn.textContent = 'Invio in corso...';
    $proposeError.classList.remove('show');

    apiPost('/api/hunts', body).then(function (res) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Proponi alla Community';

      if (res.error) {
        if (res.existingSlug) {
          showProposeError(res.error);
          closeProposeModal();
          openDetailModal(res.existingSlug);
          return;
        }
        // Machine of War: match catalogo Shopify
        if (res.catalogMatch) {
          handleCatalogMatch(res, body);
          return;
        }
        showProposeError(res.error);
        return;
      }

      closeProposeModal();
      showToast('Gioco proposto! La caccia e iniziata', 'success');

      // Add to local state
      if (res.hunt) {
        state.hunts.unshift({
          slug: res.hunt.slug,
          name: res.hunt.name,
          image: res.hunt.image,
          thumbnail: res.hunt.thumbnail,
          status: 'proposed',
          froggerCount: 1,
          proposedAt: res.hunt.proposedAt,
          updatedAt: res.hunt.updatedAt,
          year: res.hunt.year,
          minPlayers: res.hunt.minPlayers,
          maxPlayers: res.hunt.maxPlayers,
          playingTime: res.hunt.playingTime,
          categories: res.hunt.categories,
          bggRating: res.hunt.bggRating
        });
        state.myHuntSlugs.push(res.hunt.slug);
      }
      renderGrid();
      updateStats();
    }).catch(function () {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Proponi alla Community';
      showProposeError('Errore di connessione. Riprova.');
    });
  }

  function showProposeError(msg) {
    $proposeError.textContent = msg;
    $proposeError.classList.add('show');
  }

  // Machine of War: gestisce il match col catalogo Shopify
  function handleCatalogMatch(res, originalBody) {
    var m = res.catalogMatch;
    if (m.reason === 'in_stock') {
      // Blocco totale: gioco disponibile → invita ad acquistarlo
      $proposeError.innerHTML =
        '<div style="text-align:left;padding:12px;background:#d1fae5;border-radius:10px;border-left:4px solid #10b981">' +
          '<div style="font-weight:800;color:#065f46;margin-bottom:6px">&#x2705; Buone notizie!</div>' +
          '<div style="font-size:.9rem;color:#333;margin-bottom:10px">' +
            '<strong>' + escHtml(m.title) + '</strong> e\' gia\' disponibile su FroGames. Nessun bisogno di aprire una caccia.' +
          '</div>' +
          '<a href="' + escHtml(m.url) + '" target="_blank" rel="noopener" style="display:inline-block;background:#10b981;color:#fff;padding:10px 18px;border-radius:8px;text-decoration:none;font-weight:700;font-size:.9rem">&#x1F6D2; Vai al prodotto &rarr;</a>' +
        '</div>';
      $proposeError.classList.add('show');
      return;
    }
    if (m.reason === 'out_of_stock') {
      // Chiedi conferma per "segnalare restock"
      $proposeError.innerHTML =
        '<div style="text-align:left;padding:12px;background:#fef3c7;border-radius:10px;border-left:4px solid #F4C430">' +
          '<div style="font-weight:800;color:#92400e;margin-bottom:6px">&#x1F4E5; Gia\' a catalogo, ma esaurito</div>' +
          '<div style="font-size:.9rem;color:#333;margin-bottom:10px">' +
            '<strong>' + escHtml(m.title) + '</strong> e\' gia\' nel nostro catalogo ma attualmente esaurito. Vuoi segnalarlo per il restock?' +
          '</div>' +
          '<button id="fhConfirmRestock" style="background:#F4C430;color:#1a1a1a;border:2px solid #1a1a1a;padding:10px 18px;border-radius:8px;font-weight:800;font-size:.9rem;cursor:pointer">&#x1F44D; Si, segnala restock</button>' +
        '</div>';
      $proposeError.classList.add('show');
      var btn = document.getElementById('fhConfirmRestock');
      if (btn) {
        btn.addEventListener('click', function () {
          btn.disabled = true;
          btn.textContent = 'Invio...';
          var retry = Object.assign({}, originalBody, { confirmRestock: true });
          apiPost('/api/hunts', retry).then(function (r2) {
            if (r2.error) {
              showProposeError(r2.error);
              return;
            }
            closeProposeModal();
            showToast('Restock segnalato! Ti avvertiamo appena torna', 'success');
            if (r2.hunt) {
              state.hunts.unshift(r2.hunt);
              state.myHuntSlugs.push(r2.hunt.slug);
              renderGrid();
              updateStats();
            }
          });
        });
      }
      return;
    }
    showProposeError(res.error || 'Impossibile proporre questo gioco');
  }

  // ── ADMIN: UPDATE FROM CARD ─────────────────────────────
  function adminUpdateFromCard(slug) {
    var statusEl = document.querySelector('[data-admin-status="' + slug + '"]');
    var noteEl = document.querySelector('[data-admin-note="' + slug + '"]');
    if (!statusEl) return;

    var newStatus = statusEl.value;
    var newNote = noteEl ? noteEl.value : '';

    apiPost('/api/admin/update-status', {
      slug: slug,
      status: newStatus,
      note: newNote
    }).then(function (res) {
      if (res.error) {
        showToast(res.error, 'error');
        return;
      }
      // Update local state
      var hunt = state.hunts.find(function (h) { return h.slug === slug; });
      if (hunt) {
        hunt.status = newStatus;
        hunt.statusNote = newNote;
      }
      showToast('Stato aggiornato!', 'success');
    }).catch(function () {
      showToast('Errore nel salvataggio', 'error');
    });
  }

  // ── DEEP LINK ───────────────────────────────────────────
  function handleDeepLink() {
    var params = new URLSearchParams(window.location.search);
    var huntSlug = params.get('hunt');
    if (huntSlug) {
      // Wait for data to load, then open
      var check = setInterval(function () {
        if (!state.loading) {
          clearInterval(check);
          openDetailModal(huntSlug);
        }
      }, 100);
    }
  }

  // ── UPDATE STATS ────────────────────────────────────────
  function updateStats() {
    apiGet('/api/stats').then(function (data) {
      state.stats = data;
      renderStats();
    });
  }

  // ── TRENDING SECTION ─────────────────────────────────────
  function renderTrending() {
    if (!state.trending || !state.trending.length) return;
    var container = document.getElementById('fhTrending');
    if (!container) {
      container = document.createElement('div');
      container.id = 'fhTrending';
      $grid.parentNode.insertBefore(container, $grid);
    }
    var html = '<div class="fh-trending">';
    html += '<div class="fh-section-title">&#x1F525; Caldi Questa Settimana</div>';
    html += '<div class="fh-trending__hint">Scorri per vedere tutti</div>';
    html += '<div class="fh-trending__wrapper"><div class="fh-trending__scroll">';
    state.trending.forEach(function (h) {
      var img = h.thumbnail || h.image || '';
      html += '<div class="fh-trending-card" data-slug="' + h.slug + '">';
      var trendImg = img ? 'https://wsrv.nl/?url=' + encodeURIComponent(img) + '&w=400&h=250&fit=cover&output=webp&q=85' : '';
      html += trendImg ? '<img class="fh-trending-card__img" src="' + escHtml(trendImg) + '" alt="">' : '';
      html += '<div class="fh-trending-card__body">';
      html += '<div class="fh-trending-card__name">' + escHtml(h.name) + '</div>';
      html += '<div class="fh-trending-card__meta"><span><img src="https://cdn.shopify.com/s/files/1/0887/8905/7863/files/logo_9581a5e6-925f-4c66-ab2c-708dac0606f5.png?v=1775011264" alt="" class="fh-logo-icon"> ' + (h.froggerCount || 0) + '</span><span class="fh-badge fh-badge--' + h.status + '" style="position:static;font-size:.55rem;padding:2px 6px">' + statusLabel(h.status) + '</span></div>';
      html += '</div></div>';
    });
    html += '</div></div></div>';
    container.innerHTML = html;

    // Click handler
    container.addEventListener('click', function (e) {
      var card = e.target.closest('.fh-trending-card');
      if (card) openDetailModal(card.getAttribute('data-slug'));
    });
  }

  // ── HALL OF FAME ────────────────────────────────────────
  function renderHallOfFame() {
    var found = state.hunts.filter(function (h) { return h.status === 'found'; });
    if (!found.length) return '';
    found.sort(function (a, b) { return new Date(b.updatedAt) - new Date(a.updatedAt); });
    var html = '<div class="fh-halloffame">';
    html += '<div class="fh-section-title">&#x1F3C6; Trovati di Recente</div>';
    found.slice(0, 5).forEach(function (h) {
      var img = h.thumbnail || h.image || '';
      html += '<div class="fh-hof-card" data-slug="' + h.slug + '">';
      html += img ? '<img class="fh-hof-card__img" src="' + escHtml(img) + '" alt="">' : '';
      html += '<div class="fh-hof-card__info">';
      html += '<div class="fh-hof-card__name">' + escHtml(h.name) + '</div>';
      html += '<div class="fh-hof-card__status">&#x2705; ' + statusLabel(h.status) + '</div>';
      html += '</div>';
      if (h.shopifyProductUrl) html += '<a class="fh-hof-card__link" href="' + escHtml(h.shopifyProductUrl) + '">' + t('acquista', 'Acquista') + '</a>';
      html += '</div>';
    });
    html += '</div>';
    return html;
  }

  // ── MY STATS ────────────────────────────────────────────
  function renderMyStats() {
    if (!customerId || !state.myHuntSlugs.length) return '';
    var total = state.myHuntSlugs.length;
    var foundCount = 0;
    var searchingCount = 0;
    state.hunts.forEach(function (h) {
      if (state.myHuntSlugs.indexOf(h.slug) === -1) return;
      if (h.status === 'found') foundCount++;
      if (h.status === 'searching') searchingCount++;
    });
    return '<div class="fh-my-stats">' +
      '<div class="fh-my-stats__item"><img src="https://cdn.shopify.com/s/files/1/0887/8905/7863/files/logo_9581a5e6-925f-4c66-ab2c-708dac0606f5.png?v=1775011264" alt="" class="fh-logo-icon"> Segui <strong>' + total + '</strong> gioch' + (total === 1 ? 'io' : 'i') + '</div>' +
      '<div class="fh-my-stats__item">&#x2705; <strong>' + foundCount + '</strong> trovati</div>' +
      '<div class="fh-my-stats__item">&#x1F50D; <strong>' + searchingCount + '</strong> in ricerca</div>' +
    '</div>';
  }

  // ── REOPEN REQUEST ──────────────────────────────────────
  function renderReopenBar(hunt) {
    // Machine of War: riapertura ha senso SOLO per out_of_print / unavailable, mai per 'found'
    // (se è trovato, l'abbiamo — non c'è nulla da riaprire)
    var reopenableStatuses = ['out_of_print', 'unavailable'];
    if (!reopenableStatuses.includes(hunt.status)) return '';
    var count = hunt.reopenCount || 0;
    return '<div class="fh-reopen-bar">' +
      '<div class="fh-reopen-bar__text">' +
        (count > 0 ? '<strong>' + count + '</strong> person' + (count > 1 ? 'e' : 'a') + ' ' + (count > 1 ? 'vogliono' : 'vuole') + ' riaprire questa ricerca' : 'Vorresti che cercassimo di nuovo questo gioco?') +
      '</div>' +
      (customerId ? '<button class="fh-reopen-bar__btn" id="fhReopenBtn">Richiedi Riapertura</button>' : '') +
    '</div>';
  }

  // Machine of War: verifica se un URL prodotto Shopify è valido (per non mostrare bottoni rotti)
  function isValidShopUrl(u) {
    if (!u || typeof u !== 'string') return false;
    var t = u.trim();
    return /^https?:\/\/[^\s]+$/i.test(t) || /^\/[^\s]*$/.test(t);
  }

  function handleReopenClick(slug) {
    var btn = document.getElementById('fhReopenBtn');
    if (!btn) return;
    btn.disabled = true;
    btn.textContent = 'Invio...';
    apiPost('/api/hunts', {
      action: 'reopen-request',
      customerId: String(customerId),
      customerName: customerName,
      slug: slug
    }).then(function (res) {
      if (res.error) { showToast(res.error, 'error'); btn.disabled = false; btn.textContent = 'Richiedi Riapertura'; return; }
      showToast('Richiesta inviata! FroGames la valutera', 'success');
      btn.textContent = 'Richiesta inviata';
      var hunt = state.hunts.find(function (h) { return h.slug === slug; });
      if (hunt) hunt.reopenCount = res.reopenCount;
    }).catch(function () {
      showToast('Errore', 'error');
      btn.disabled = false;
      btn.textContent = 'Richiedi Riapertura';
    });
  }

  // ── SHARE ───────────────────────────────────────────────
  function handleShare(slug, name) {
    var url = 'https://frogames.it/pages/froghunt?hunt=' + slug;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        showToast('Link copiato!', 'success');
      });
    } else {
      // Fallback
      var input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      showToast('Link copiato!', 'success');
    }
  }

  // ── COMMENTS ─────────────────────────────────────────────
  function renderComments(comments, slug) {
    var html = '<div class="fh-comments">';
    html += '<h4 class="fh-comments__title">&#x1F4AC; Commenti (' + comments.length + ')</h4>';

    if (comments.length) {
      html += '<div class="fh-comments__list">';
      comments.slice().reverse().forEach(function (c) {
        // Machine of War: commento admin — badge dorato + sfondo distintivo
        var isAdmin = c.isAdmin === true || c.author === 'admin';
        var extraClass = isAdmin ? ' fh-comment--admin' : '';
        var authorBadge = isAdmin
          ? '<span class="fh-comment__admin-badge">&#x1F438; ADMIN FroGames</span>'
          : '<strong class="fh-comment__name">' + escHtml(c.name) + '</strong>';
        html += '<div class="fh-comment' + extraClass + '">' +
          '<div class="fh-comment__header">' +
            authorBadge +
            '<span class="fh-comment__date">' + formatDate(c.at) + '</span>' +
          '</div>' +
          '<p class="fh-comment__text">' + escHtml(c.text) + '</p>' +
        '</div>';
      });
      html += '</div>';
    } else {
      html += '<p class="fh-comments__empty">Nessun commento. Sii il primo!</p>';
    }

    if (customerId) {
      html += '<div class="fh-comments__form">' +
        '<textarea class="fh-comments__input" id="fhCommentInput" placeholder="Scrivi un commento..." maxlength="500"></textarea>' +
        '<button class="fh-comments__submit" id="fhCommentSubmit">Invia</button>' +
      '</div>';
    } else {
      html += '<p class="fh-comments__login"><a href="' + loginUrl + '">Accedi</a> per commentare</p>';
    }
    html += '</div>';
    return html;
  }

  function submitComment(slug, comments) {
    var input = document.getElementById('fhCommentInput');
    var btn = document.getElementById('fhCommentSubmit');
    var text = input ? input.value.trim() : '';
    if (!text) return;

    if (!confirm('Vuoi pubblicare questo commento?')) return;

    btn.disabled = true;
    btn.textContent = 'Invio...';

    apiPost('/api/comments', {
      slug: slug,
      customerId: String(customerId),
      customerName: customerName,
      text: text
    }).then(function (res) {
      btn.disabled = false;
      btn.textContent = 'Invia';
      if (res.error) { showToast(res.error, 'error'); return; }
      comments.push(res.comment);
      // Re-render comments section
      var commentsEl = document.querySelector('.fh-comments');
      if (commentsEl) {
        commentsEl.outerHTML = renderComments(comments, slug);
        // Rebind
        var newBtn = document.getElementById('fhCommentSubmit');
        if (newBtn) newBtn.addEventListener('click', function () { submitComment(slug, comments); });
        var newInput = document.getElementById('fhCommentInput');
        if (newInput) newInput.addEventListener('keydown', function (e) {
          // Enter = new line, not submit
        });
      }
      showToast('Commento aggiunto!', 'success');
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Invia';
      showToast('Errore di connessione', 'error');
    });
  }

  // ── TOAST ───────────────────────────────────────────────
  function showToast(message, type) {
    $toast.textContent = message;
    $toast.className = 'fh-toast show';
    if (type === 'success') $toast.classList.add('fh-toast--success');
    if (type === 'error') $toast.classList.add('fh-toast--error');
    setTimeout(function () {
      $toast.classList.remove('show');
    }, 3000);
  }

  // ── UTILITIES ───────────────────────────────────────────
  function statusLabel(status) {
    var map = {
      proposed: t('st_proposed', 'Proposto'),
      searching: t('st_searching', 'In Ricerca'),
      ordered: t('st_ordered', 'Ordinato'),
      found: t('st_found', 'Trovato!'),
      out_of_print: t('st_oop', 'Fuori Prod.'),
      unavailable: t('st_unav', 'Non Disponibile')
    };
    return map[status] || status;
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return d.toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  function escHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Card: resize via wsrv.nl (free image CDN) — 300px WebP ~20KB
  function cardImageUrl(url) {
    if (!url) return '';
    return 'https://wsrv.nl/?url=' + encodeURIComponent(url) + '&w=300&h=300&fit=cover&output=webp&q=80';
  }

  // Detail modal: larger but still optimized
  function fullImageUrl(url) {
    if (!url) return '';
    return 'https://wsrv.nl/?url=' + encodeURIComponent(url) + '&w=600&fit=inside&output=webp&q=85';
  }

  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      var args = arguments;
      var ctx = this;
      timer = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  // ════════════════════════════════════════════════════════════
  // DISCOVERY RAILS — Spotify-style curated carousels
  // ════════════════════════════════════════════════════════════
  var DEAD = ['found','out_of_print','unavailable'];
  var SEVEN_DAYS = 7*86400000;
  var THIRTY_DAYS = 30*86400000;

  function huntDate(h, field){
    var v = h[field];
    if(!v) return 0;
    var t = (typeof v === 'string') ? new Date(v).getTime() : v;
    return isNaN(t) ? 0 : t;
  }

  function railCardHtml(h, opts){
    opts = opts || {};
    var img = h.image || h.thumbnail || '';
    var imgSrc = img ? 'https://wsrv.nl/?url='+encodeURIComponent(img)+'&w=400&h=400&fit=cover&output=webp&q=82' : '';
    var statusLabels = {proposed:'Proposto', searching:'In Ricerca', ordered:'Ordinato', found:'Trovato!', out_of_print:'Fuori Prod.', unavailable:'Non Disp.'};
    var badgeText = statusLabels[h.status] || h.status;
    var isFollowed = (state.myHuntSlugs || []).indexOf(h.slug) !== -1;

    // Overlay pill sulla cover: solo per rail scoperta (weekly/fresh)
    // Per rail "Le tue ricerche" (meritBadges:true) la relazione è già implicita → nessuna pill duplicata
    var extra = '';
    if(opts.showWeekly && h.weeklyFroggerCount){
      extra = '<span class="fh-rcard__chip fh-rcard__chip--hot">'
        + '&#x1F525; +'+h.weeklyFroggerCount
        + '<span class="fh-rcard__chip-long"> settimana</span>'
        + '</span>';
    } else if(opts.showFresh){
      extra = '<span class="fh-rcard__chip fh-rcard__chip--new">' + t('nuovo', 'NUOVO') + '</span>';
    }
    // Nota: le vecchie pill "Tua proposta"/"Seguito" sono state rimosse (duplicavano info del rail)

    // Machine of War (Fase 1): chip "Acquistabile" per hunts nel rail mine
    // - verde se comprabile ora
    // - arancione se in pausa (stock temporaneamente 0)
    var purchasableChip = '';
    if(opts.showPurchasable && h.purchasableSince){
      if(h.purchasablePaused){
        purchasableChip = '<span class="fh-rcard__badge" style="background:#fed7aa;color:#7c2d12">&#x1F553; Esaurito</span>';
      } else {
        purchasableChip = '<span class="fh-rcard__badge" style="background:#d1fae5;color:#065f46">&#x1F6D2; Acquistabile</span>';
      }
    }

    // Machine of War: badge difficolta' + tipo ricerca sotto al nome
    var DIFF_MAP = {
      easy:        {label:'🟢 Facile',            bg:'#d1fae5', color:'#065f46'},
      medium:      {label:'🟡 Media',             bg:'#fef3c7', color:'#92400e'},
      hard:        {label:'🟠 Difficile',         bg:'#fed7aa', color:'#9a3412'},
      very_hard:   {label:'🔴 Molto Difficile',    bg:'#fee2e2', color:'#991b1b'},
      impossible:  {label:'💎 Rarissimo',         bg:'#1f2937', color:'#f4c430'}
    };
    var TYPE_MAP = {
      kickstarter: {label:'🚀 Kickstarter', bg:'#ede9fe', color:'#5b21b6'},
      gamefound:   {label:'🎯 Gamefound',   bg:'#ede9fe', color:'#5b21b6'},
      reprint:     {label:'🔄 Ristampa',    bg:'#dbeafe', color:'#1e40af'},
      preorder:    {label:'🎁 Preorder',    bg:'#dbeafe', color:'#1e40af'},
      restock:     {label:'📥 Restock',     bg:'#f3e8ff', color:'#6b21a8'}
    };
    var diffBadge = (h.difficulty && DIFF_MAP[h.difficulty])
      ? '<span class="fh-rcard__badge" style="background:'+DIFF_MAP[h.difficulty].bg+';color:'+DIFF_MAP[h.difficulty].color+'">'+DIFF_MAP[h.difficulty].label+'</span>'
      : '';
    var typeBadge = (h.proposalType && TYPE_MAP[h.proposalType])
      ? '<span class="fh-rcard__badge" style="background:'+TYPE_MAP[h.proposalType].bg+';color:'+TYPE_MAP[h.proposalType].color+'">'+TYPE_MAP[h.proposalType].label+'</span>'
      : '';
    // Nelle card "Le tue ricerche" (meritBadges) NON mostro diff/type/purchasable:
    // la merit chip copre già "Trovato per te" / "Trovato ma esaurito", il purchasableChip duplica.
    var extraBadges = '';
    if(!opts.meritBadges && (diffBadge || typeBadge || purchasableChip)){
      extraBadges = '<div class="fh-rcard__badges">'+purchasableChip+diffBadge+typeBadge+'</div>';
    }
    // Gia' comprato da me: il badge "Preso" prende il posto di "Acquistabile", che
    // inviterebbe a ricomprare una cosa che ho in casa. Questa e' la card usata dal
    // catalogo e dai rail: renderCard (griglia vecchia) e' un'altra funzione.
    if(isPurchasedByMe(h.slug)){
      extraBadges = '<div class="fh-rcard__badges"><span class="fh-rcard__badge" style="background:#EAF7EF;color:#14532D;border:1px solid #9BD3AE">'
        + t('preso', '\u2714 Preso') + '</span>'+diffBadge+typeBadge+'</div>';
    }

    // Machine of War 2026: 1 SOLA merit chip con priorità chiara (Trovato > Delta > Pack > Prima)
    // Le altre non servono: 1 chip = 1 messaggio = card leggibile
    var meritHtml = '';
    var heroClass = '';
    var buyCta = '';

    // CTA "Compra ora" giallo — ATTIVO per rail Trovati (showShop) E per merit found+purchasable.
    // E' il touchpoint di conversione: se una hunt è acquistabile ora, il tasto va sempre offerto.
    if(h.status === 'found' && h.purchasableSince && !h.purchasablePaused
       && h.shopifyProductUrl && typeof isValidShopUrl === 'function' && isValidShopUrl(h.shopifyProductUrl)){
      buyCta = '<a class="fh-rcard__buy" href="' + escHtml(h.shopifyProductUrl) + '" onclick="event.stopPropagation()">&rarr; Compra ora</a>';
    }

    if(opts.meritBadges){
      var merit = null;
      var fCount = h.froggerCount || 0;
      var deltaCount = Math.max(0, fCount - 1); // Froggers dopo di te (approx)

      // Priorità 1: Trovato + acquistabile → merit + bordo verde (CTA già gestito fuori)
      if(h.status === 'found' && h.purchasableSince && !h.purchasablePaused){
        merit = { cls: 'fh-rcard__mchip--found', txt: '🎉 Trovato per te' };
        heroClass = ' fh-rcard--merit-hero';
      }
      // Priorità 2: Trovato ma esaurito
      else if(h.status === 'found' && h.purchasablePaused){
        merit = { cls: 'fh-rcard__mchip--paused', txt: '🕐 Trovato ma esaurito' };
      }
      // Priorità 3: proposer con delta significativo (+5 Frogger dopo di te)
      else if(h._isProposer && deltaCount >= 5){
        merit = { cls: 'fh-rcard__mchip--hot', txt: '🔥 +' + deltaCount + t('dopo_di_te', ' Frogger dopo di te') };
      }
      // Priorità 4: pack (segui insieme ad altri)
      else if(!h._isProposer && h._isFollower && fCount > 1){
        merit = { cls: 'fh-rcard__mchip--pack', txt: t('con_altri', '\ud83d\udc65 Con altri ') + deltaCount + ' Frogger' };
      }
      // Priorità 5: prima/unica
      else if(h._isProposer && fCount <= 1){
        merit = { cls: 'fh-rcard__mchip--first', txt: '🥇 Prima proposta' };
      }
      else if(!h._isProposer && h._isFollower && fCount === 1){
        merit = { cls: 'fh-rcard__mchip--first', txt: '🥇 Primo a seguirlo' };
      }
      // Priorità 6 (fallback): in ricerca
      else if(h.status === 'searching'){
        merit = { cls: 'fh-rcard__mchip--waiting', txt: '⏳ Stiamo scavando' };
      }

      if(merit){
        meritHtml = '<div class="fh-rcard__merit"><span class="fh-rcard__mchip ' + merit.cls + '">' + merit.txt + '</span></div>';
      }
    }

    return '<article class="fh-rcard' + heroClass + (opts.meritBadges ? ' fh-rcard--merit' : '') + '" data-slug="'+h.slug+'">' +
      '<button class="fh-rcard__cover" data-rcard-open="'+h.slug+'" type="button" aria-label="Apri '+escHtml(h.name)+'">' +
        (imgSrc ? '<img src="'+imgSrc+'" alt="" loading="lazy">' : '<div class="fh-rcard__cover-ph"></div>') +
        '<span class="fh-rcard__status fh-rcard__status--'+h.status+'">'+badgeText+'</span>' +
        (extra ? '<span class="fh-rcard__overlay">'+extra+'</span>' : '') +
      '</button>' +
      '<div class="fh-rcard__body">' +
        '<h3 class="fh-rcard__name" title="'+escHtml(h.name)+'">'+escHtml(h.name)+'</h3>' +
        meritHtml +
        extraBadges +
        '<div class="fh-rcard__meta">' +
          '<span class="fh-rcard__froggers">&#x1F465; '+(h.froggerCount||0)+'</span>' +
          (h.year ? '<span class="fh-rcard__year">'+h.year+'</span>' : '') +
        '</div>' +
        '<button class="fh-rcard__follow'+(isFollowed?' is-followed':'')+'" data-rcard-follow="'+h.slug+'" type="button">' +
          (isFollowed ? '&#x2713; Frogger' : '&#x1F49A; Diventa Frogger') +
        '</button>' +
        buyCta +
      '</div>' +
    '</article>';
  }

  function renderRail(trackId, hunts, opts){
    var el = document.getElementById(trackId);
    if(!el) return;
    if(!hunts.length){
      el.innerHTML = '<div class="fh-rail__empty">Niente da mostrare qui per ora</div>';
      var section = el.closest('.fh-rail');
      if(section && opts && opts.hideIfEmpty) section.hidden = true;
      return;
    }
    el.innerHTML = hunts.map(function(h){ return railCardHtml(h, opts); }).join('');
  }

  function railSkeletonHtml(){
    var s = '';
    for (var i = 0; i < 6; i++){
      s += '<div class="fh-rcard fh-rcard--skeleton">'
        + '<div class="fh-rcard__cover fh-rcard__cover--skel"></div>'
        + '<div class="fh-rcard__skel-line fh-rcard__skel-line--long"></div>'
        + '<div class="fh-rcard__skel-line fh-rcard__skel-line--short"></div>'
        + '</div>';
    }
    return s;
  }
  function injectRailSkeletons(){
    ['fhRailWeekly','fhRailMonth','fhRailFound','fhRailNew'].forEach(function(id){
      var el = document.getElementById(id);
      if(el && !el.children.length) el.innerHTML = railSkeletonHtml();
    });
  }
  // Run skeletons immediately at module load (page just rendered)
  injectRailSkeletons();

  function buildAndRenderRails(){
    if(!state.hunts || !state.hunts.length) return;
    var now = Date.now();
    var hunts = state.hunts;

    // 🔥 Caldi questa settimana — peso weeklyFroggerCount, escludi morti
    var weekly = hunts.filter(function(h){
      return DEAD.indexOf(h.status) === -1 && (h.weeklyFroggerCount||0) >= 1;
    }).sort(function(a,b){
      var d = (b.weeklyFroggerCount||0) - (a.weeklyFroggerCount||0);
      return d !== 0 ? d : (b.froggerCount||0) - (a.froggerCount||0);
    }).slice(0, 12);

    // 📈 Top del mese — hunts attive, ordinate per froggerCount, NON gia\' in weekly per evitare overlap
    var weeklySlugs = {};
    weekly.forEach(function(h){ weeklySlugs[h.slug] = true; });
    var month = hunts.filter(function(h){
      return DEAD.indexOf(h.status) === -1 && (h.froggerCount||0) >= 2 && !weeklySlugs[h.slug];
    }).sort(function(a,b){
      return (b.froggerCount||0) - (a.froggerCount||0);
    }).slice(0, 12);

    // ✅ Trovati di recente — ultimi 90 giorni di found, ordinati per updatedAt desc
    var foundCutoff = now - 90*86400000;
    var found = hunts.filter(function(h){
      return h.status === 'found' && huntDate(h, 'updatedAt') >= foundCutoff;
    }).sort(function(a,b){
      return huntDate(b, 'updatedAt') - huntDate(a, 'updatedAt');
    }).slice(0, 12);
    // fallback se non ci sono trovati recenti, mostriamo gli ultimi trovati storici
    if(found.length === 0){
      found = hunts.filter(function(h){ return h.status === 'found'; })
        .sort(function(a,b){ return huntDate(b, 'updatedAt') - huntDate(a, 'updatedAt'); })
        .slice(0, 8);
    }

    // 🆕 Appena proposti — ultimi 14 giorni in stato proposed
    var freshCutoff = now - 14*86400000;
    var fresh = hunts.filter(function(h){
      return h.status === 'proposed' && huntDate(h, 'proposedAt') >= freshCutoff;
    }).sort(function(a,b){
      return huntDate(b, 'proposedAt') - huntDate(a, 'proposedAt');
    }).slice(0, 12);
    // fallback: le piu\' recenti proposte se non ci sono freshe
    if(fresh.length === 0){
      fresh = hunts.filter(function(h){ return h.status === 'proposed'; })
        .sort(function(a,b){ return huntDate(b, 'proposedAt') - huntDate(a, 'proposedAt'); })
        .slice(0, 8);
    }

    // NUOVO 2026: catalogo grid verticale con chip filtri (sostituisce i 4 rail carousel)
    // Popola l'array globale + trigger render (rispetta filtri correnti se già settati)
    __fhAllHunts = hunts.slice();
    renderCatalog();
    // I DOM element dei vecchi rail (fhRailWeekly, fhRailMonth, fhRailFound, fhRailNew) sono stati rimossi.
    // Nessuna renderRail necessaria per la parte scoperta.

    // 💚 Le tue ricerche (solo loggato) — proposte + seguite insieme, con badge distintivi
    if(customerId){
      var cid = String(customerId);
      var followed = new Set(state.myHuntSlugs || []);
      // Hunt CHIUSE (trovate / fuori catalogo): restano in lista solo finche' le segui.
      // Il proponente ci finiva dentro per sempre anche dopo "Togli dalla mia lista",
      // perche' proposedByCustomerId non cambia con l'unfollow.
      var CLOSED_MINE = ['found', 'out_of_print', 'unavailable'];
      var mine = hunts.filter(function(h){
        var isFollow = followed.has(h.slug);
        var isProposer = h.proposedByCustomerId && h.proposedByCustomerId === cid;
        if (CLOSED_MINE.indexOf(h.status) !== -1) return isFollow;
        return isFollow || isProposer;
      }).map(function(h){
        // Marca tipo relazione per il badge card
        var out = Object.assign({}, h);
        out._isProposer = h.proposedByCustomerId === cid;
        out._isFollower = followed.has(h.slug);
        return out;
      });
      // Ordinamento: proposte in cima, poi per updatedAt desc
      mine.sort(function(a,b){
        if(a._isProposer !== b._isProposer) return a._isProposer ? -1 : 1;
        return huntDate(b, 'updatedAt') - huntDate(a, 'updatedAt');
      });
      // Sidebar sticky "Le tue ricerche" (lista compatta, sempre viva)
      renderMineList(mine);
      // Attiva shell 2-col se ha almeno una hunt propria
      if(typeof updateShellLayout === 'function') updateShellLayout(mine.length > 0);
      // Bottone topbar "Le mie ricerche"
      var topMine = document.getElementById('fhTopbarMine');
      if(topMine){
        topMine.hidden = mine.length === 0;
        var countEl = topMine.querySelector('.fh-topbar__mine-count');
        if(!countEl){
          countEl = document.createElement('span');
          countEl.className = 'fh-topbar__mine-count';
          topMine.appendChild(countEl);
        }
        countEl.textContent = mine.length;
      }
    }

    // Wire up rail card actions
    bindRailEvents();
  }

  function bindRailEvents(){
    // Arrows
    document.querySelectorAll('[data-rail-arrow]').forEach(function(btn){
      if(btn._b) return; btn._b = true;
      btn.addEventListener('click', function(){
        var targetId = btn.getAttribute('data-rail-target');
        var dir = btn.getAttribute('data-rail-arrow');
        var track = document.getElementById(targetId);
        if(!track) return;
        var amount = track.clientWidth * 0.85;
        track.scrollBy({ left: dir === 'next' ? amount : -amount, behavior: 'smooth' });
      });
    });
    // Aggiorna visibilita\' arrows e sfumature laterali al scroll
    document.querySelectorAll('.fh-rail__track').forEach(function(track){
      if(track._scroll) return; track._scroll = true;
      var update = function(){
        var v = track.closest('.fh-rail__viewport');
        if(!v) return;
        var prev = v.querySelector('.fh-rail__arrow--prev');
        var next = v.querySelector('.fh-rail__arrow--next');
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if(prev) prev.classList.toggle('is-hidden', atStart);
        if(next) next.classList.toggle('is-hidden', atEnd);
        v.classList.toggle('is-at-start', atStart);
        v.classList.toggle('is-at-end', atEnd);
      };
      track.addEventListener('scroll', update, { passive: true });
      setTimeout(update, 50);
      window.addEventListener('resize', update);
    });

    document.querySelectorAll('[data-rcard-follow]').forEach(function(btn){
      if(btn._b) return; btn._b = true;
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var slug = btn.getAttribute('data-rcard-follow');
        handleFollowClick(slug);
      });
    });
    document.querySelectorAll('[data-rcard-open]').forEach(function(btn){
      if(btn._b) return; btn._b = true;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var slug = btn.getAttribute('data-rcard-open');
        if(slug && typeof openDetailModal === 'function') openDetailModal(slug);
      });
    });
  }

  // Machine of War 2026: riempie il RIBBON + prepara dati per il modal profilo hunter
  function loadMyProfileStats(){
    var ribbon = document.getElementById('fhRibbon');
    if(!ribbon) return;
    var cid = ribbon.getAttribute('data-customer-id');
    if(!cid || cid === '' || cid === 'null') return;

    fetch(WORKER_URL + '/api/customer-stats/' + cid, { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(s){
        if(!s || s.error) return;

        // Salva stats per apertura modal
        window.__fhStats = s;

        function setNum(id, n){ var el = document.getElementById(id); if(el) el.textContent = (n == null ? '0' : n); }

        // Livello + colore avatar (7 stati) — condiviso ribbon + modal
        var levelColors = {
          new_frogger:        { bg: '#A7F3D0', fg: '#065F46' },
          frogger_exploring:  { bg: '#FDE68A', fg: '#78350F' },
          rarity_hunter:      { bg: 'linear-gradient(135deg,#5EEAD4,#0891B2)', fg: '#fff' },
          frogger_targeted:   { bg: '#FED7AA', fg: '#7C2D12' },
          frogger_active:     { bg: '#10B981', fg: '#fff' },
          hunter:             { bg: 'linear-gradient(135deg,#FBBF24,#F59E0B)', fg: '#fff' },
          legend:             { bg: 'linear-gradient(135deg,#8B5CF6,#EC4899)', fg: '#fff' }
        };
        var lvlKey = s.level || 'new_frogger';
        var lvlColor = levelColors[lvlKey] || levelColors.new_frogger;
        var lvlLabel = s.levelLabel || '🌱 Nuovo Frogger';

        var lvlRibbon = document.getElementById('fhRibbonLevel');
        if(lvlRibbon) lvlRibbon.textContent = lvlLabel;
        ['fhRibbonAvatar', 'fhHunterAvatar'].forEach(function(id){
          var el = document.getElementById(id);
          if(el){ el.style.background = lvlColor.bg; el.style.color = lvlColor.fg; }
        });
        var lvlModal = document.getElementById('fhHunterLevel');
        if(lvlModal) lvlModal.textContent = lvlLabel;

        // Numeri onesti (contatori unici)
        setNum('fhRibbonProposed', s.proposedCount || 0);
        setNum('fhRibbonFollowed', s.followedCount || 0);
        setNum('fhRibbonPurchasable', s.uniquePurchasableCount || 0);
        setNum('fhRibbonPurchased', s.purchasedCount || 0);

        // Progresso: mostrato inline nel ribbon (solo desktop, viene nascosto CSS su mobile)
        var progEl = document.getElementById('fhRibbonProgress');
        if(progEl && s.progress && s.progress.message){
          progEl.textContent = s.progress.message;
        }

        // Mostra il ribbon solo se il cliente ha almeno una hunt o un acquisto
        var hasActivity = (s.uniqueHuntCount || 0) > 0 || (s.purchasedCount || 0) > 0;
        ribbon.hidden = !hasActivity;

        // === Riempi contenuto MODAL profilo hunter ===
        var totalHunts = s.uniqueHuntCount || 0;
        var purchasable = s.uniquePurchasableCount || 0;
        var inProgress = s.uniqueInProgressCount || 0;
        var impossible = s.uniqueImpossibleCount || 0;

        var bar = document.getElementById('fhHunterBar');
        var legend = document.getElementById('fhHunterLegend');
        if(bar){
          if(totalHunts > 0){
            var segments = [
              { count: purchasable, label: 'Acquistabili', color: '#10B981' },
              { count: inProgress,  label: 'In ricerca',   color: '#F59E0B' },
              { count: impossible,  label: 'Introvabili',  color: '#0891B2' }
            ];
            bar.innerHTML = segments.filter(function(x){ return x.count > 0; }).map(function(x){
              var pct = Math.round((x.count / totalHunts) * 1000) / 10;
              return '<span style="width:' + pct + '%;background:' + x.color + '" title="' + x.label + ': ' + x.count + '"></span>';
            }).join('');
            if(legend){
              legend.innerHTML = segments.filter(function(x){ return x.count > 0; }).map(function(x){
                return '<span><i style="background:' + x.color + '"></i>' + x.label + ' <b>' + x.count + '</b></span>';
              }).join('');
            }
          } else {
            bar.innerHTML = '<span style="width:100%;background:#f0f0f0"></span>';
            if(legend) legend.innerHTML = '<span style="color:#999;font-style:italic">Ancora nessuna hunt gestita — buttati!</span>';
          }
        }

        // Evidenzia livello corrente nel modal ladder
        var ladder = document.getElementById('fhHunterLadder');
        if(ladder){
          ladder.querySelectorAll('li').forEach(function(li){
            var matches = (li.getAttribute('data-lv') || '').split(/\s+/);
            li.classList.toggle('is-current', matches.indexOf(lvlKey) !== -1);
          });
        }

        // Popola i 3 KPI "Il tuo contributo" — dati neutri, parlano da soli
        var purchases = s.purchasedCount12mo != null ? s.purchasedCount12mo : (s.purchasedCount || 0);
        var opportunities = s.uniquePurchasableCount || 0;
        var conv = s.conversionRate;
        var kpiP = document.getElementById('fhKpiPurchases');
        var kpiO = document.getElementById('fhKpiOpportunities');
        var kpiC = document.getElementById('fhKpiConversion');
        if(kpiP) kpiP.textContent = purchases;
        if(kpiO) kpiO.textContent = opportunities;
        if(kpiC) kpiC.textContent = (opportunities === 0 || conv == null) ? '—' : (conv + '%');
      })
      .catch(function(){});
  }

  // Modal profilo hunter: apri da ribbon, chiudi da X / overlay / ESC
  function initHunterModal(){
    var modal = document.getElementById('fhHunterModal');
    var openBtn = document.getElementById('fhRibbonMoreBtn');
    var closeBtn = document.getElementById('fhHunterModalClose');
    if(!modal) return;
    function open(){
      modal.classList.add('is-open'); document.body.style.overflow='hidden';
      loadFroggerNickname(); // lazy load nickname al primo open
      loadTelegramStatus();
      initTelegramUI();
    }
    function close(){ modal.classList.remove('is-open'); document.body.style.overflow=''; }
    if(openBtn) openBtn.addEventListener('click', open);
    if(closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function(e){ if(e.target === modal) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    // Wire nickname edit/save
    initNicknameUI();
  }

  var __fhNickState = { loaded: false, current: '', publicOptIn: true };
  function loadFroggerNickname(){
    var wrap = document.querySelector('.fh-nick');
    if(!wrap) return;
    var cid = (window.__frogHunt && window.__frogHunt.customerId) || null;
    if(!cid) return;
    // Fase A: aggiorna sempre contatori rete (leggeri, fresh ad ogni open)
    loadNetworkCounters(cid);
    if(__fhNickState.loaded) return; // nickname carica solo una volta per sessione
    var firstName = wrap.getAttribute('data-first-name') || '';
    fetch(WORKER_URL + '/api/frogger/profile', {
      method: 'POST',
      cache: 'no-store',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ customerId: String(cid), firstName: firstName, action: 'get' })
    }).then(function(r){ return r.json(); }).then(function(d){
      if(!d || !d.profile) return;
      __fhNickState.loaded = true;
      __fhNickState.current = d.profile.nickname || '';
      __fhNickState.publicOptIn = !!d.profile.publicOptIn;
      renderNickname();
      // Preferenze mail (default: comingSoon=true, closed=false, digest=true)
      var mp = d.profile.mailPrefs || {};
      var cs = document.getElementById('fhMprefComingSoon');
      var cl = document.getElementById('fhMprefClosed');
      var dg = document.getElementById('fhMprefDigest');
      if(cs) cs.checked = mp.comingSoon !== false;
      if(cl) cl.checked = mp.closed === true;
      if(dg) dg.checked = mp.digest !== false;
      initMailPrefsListeners();
    }).catch(function(){});
  }

  var __fhMprefWired = false;
  function initMailPrefsListeners(){
    if(__fhMprefWired) return;
    __fhMprefWired = true;
    ['fhMprefComingSoon','fhMprefClosed','fhMprefDigest'].forEach(function(id){
      var el = document.getElementById(id);
      if(!el) return;
      el.addEventListener('change', function(){ saveMailPrefs(); });
    });
  }

  var __fhMprefSaveTimer = null;
  function saveMailPrefs(){
    var cid = (window.__frogHunt && window.__frogHunt.customerId) || null;
    if(!cid) return;
    var cs = document.getElementById('fhMprefComingSoon');
    var cl = document.getElementById('fhMprefClosed');
    var dg = document.getElementById('fhMprefDigest');
    var payload = {
      customerId: String(cid),
      action: 'update',
      mailPrefs: {
        comingSoon: !!(cs && cs.checked),
        closed: !!(cl && cl.checked),
        digest: !!(dg && dg.checked)
      }
    };
    // Debounce: se cliente cambia 3 toggle in un secondo → 1 sola call
    clearTimeout(__fhMprefSaveTimer);
    __fhMprefSaveTimer = setTimeout(function(){
      fetch(WORKER_URL + '/api/frogger/profile', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(payload)
      }).then(function(r){ return r.json(); }).then(function(d){
        if(d && d.success){
          if(typeof showToast === 'function') showToast('✓ Preferenze mail salvate', 'success');
        } else {
          if(typeof showToast === 'function') showToast('Errore salvataggio preferenze', 'error');
        }
      }).catch(function(){
        if(typeof showToast === 'function') showToast('Errore di rete', 'error');
      });
    }, 400);
  }

  // Telegram DM: stato link + genera codice + scollega
  function loadTelegramStatus(){
    var wrap = document.getElementById('fhTg');
    if(!wrap) return;
    var cid = (window.__frogHunt && window.__frogHunt.customerId) || null;
    if(!cid) return;
    fetch(WORKER_URL + '/api/telegram/status?customerId=' + encodeURIComponent(cid), { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(d){
        var loading = document.getElementById('fhTgLoading');
        var unlinked = document.getElementById('fhTgUnlinked');
        var pending = document.getElementById('fhTgPending');
        var linked = document.getElementById('fhTgLinked');
        if(loading) loading.hidden = true;
        if(d && d.linked){
          if(linked) linked.hidden = false;
          if(unlinked) unlinked.hidden = true;
          if(pending) pending.hidden = true;
          var nameEl = document.getElementById('fhTgLinkedName');
          if(nameEl && d.link){
            var name = d.link.chatUsername ? '@' + d.link.chatUsername : (d.link.chatFirstName || 'Telegram');
            nameEl.textContent = name;
          }
        } else {
          if(unlinked) unlinked.hidden = false;
          if(pending) pending.hidden = true;
          if(linked) linked.hidden = true;
        }
      }).catch(function(){});
  }

  function initTelegramUI(){
    var connectBtn = document.getElementById('fhTgConnectBtn');
    var unlinkBtn = document.getElementById('fhTgUnlinkBtn');
    var copyBtn = document.getElementById('fhTgCopyBtn');
    var cancelBtn = document.getElementById('fhTgCancelBtn');
    if(!connectBtn || connectBtn._b) return;
    connectBtn._b = true;

    connectBtn.addEventListener('click', function(){
      var cid = (window.__frogHunt && window.__frogHunt.customerId) || null;
      if(!cid) return;
      connectBtn.disabled = true;
      fetch(WORKER_URL + '/api/telegram/generate-code', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ customerId: String(cid) })
      }).then(function(r){ return r.json(); }).then(function(d){
        connectBtn.disabled = false;
        if(!d || (!d.code && !d.alreadyLinked)){
          if(typeof showToast === 'function') showToast('Errore generazione codice', 'error');
          return;
        }
        if(d.alreadyLinked){
          loadTelegramStatus(); // refresh UI, mostra stato collegato
          return;
        }
        // Mostra fase pending
        var unlinked = document.getElementById('fhTgUnlinked');
        var pending = document.getElementById('fhTgPending');
        if(unlinked) unlinked.hidden = true;
        if(pending) pending.hidden = false;
        var codeEl = document.getElementById('fhTgCode');
        var linkEl = document.getElementById('fhTgDeepLink');
        if(codeEl) codeEl.textContent = '/start ' + d.code;
        if(linkEl) linkEl.setAttribute('href', d.deepLink);
        // Poll ogni 5s per rilevare quando il link avviene
        clearInterval(window.__fhTgPoll);
        window.__fhTgPoll = setInterval(function(){
          fetch(WORKER_URL + '/api/telegram/status?customerId=' + encodeURIComponent(cid), { cache: 'no-store' })
            .then(function(r){ return r.json(); })
            .then(function(s){
              if(s && s.linked){
                clearInterval(window.__fhTgPoll);
                loadTelegramStatus();
                if(typeof showToast === 'function') showToast('✓ Telegram collegato!', 'success');
              }
            }).catch(function(){});
        }, 5000);
      }).catch(function(){
        connectBtn.disabled = false;
        if(typeof showToast === 'function') showToast('Errore di rete', 'error');
      });
    });

    if(copyBtn) copyBtn.addEventListener('click', function(){
      var codeEl = document.getElementById('fhTgCode');
      if(!codeEl) return;
      var txt = codeEl.textContent || '';
      if(navigator.clipboard) navigator.clipboard.writeText(txt);
      if(typeof showToast === 'function') showToast('✓ Copiato: ' + txt, 'success');
    });

    if(cancelBtn) cancelBtn.addEventListener('click', function(){
      clearInterval(window.__fhTgPoll);
      var unlinked = document.getElementById('fhTgUnlinked');
      var pending = document.getElementById('fhTgPending');
      if(unlinked) unlinked.hidden = false;
      if(pending) pending.hidden = true;
    });

    if(unlinkBtn) unlinkBtn.addEventListener('click', function(){
      if(!confirm('Vuoi davvero scollegare Telegram? Non riceverai piu\' DM.')) return;
      var cid = (window.__frogHunt && window.__frogHunt.customerId) || null;
      if(!cid) return;
      fetch(WORKER_URL + '/api/telegram/unlink', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ customerId: String(cid) })
      }).then(function(r){ return r.json(); }).then(function(){
        loadTelegramStatus();
        if(typeof showToast === 'function') showToast('Telegram scollegato', 'success');
      }).catch(function(){});
    });
  }

  // Fase A: contatori "Segui / Ti seguono" nel modal profilo
  function loadNetworkCounters(cid){
    var scid = String(cid);
    Promise.all([
      fetch(WORKER_URL + '/api/frogger/my-follows?customerId=' + encodeURIComponent(scid), { cache: 'no-store' }).then(function(r){ return r.json(); }),
      fetch(WORKER_URL + '/api/frogger/my-followers?customerId=' + encodeURIComponent(scid), { cache: 'no-store' }).then(function(r){ return r.json(); })
    ]).then(function(res){
      var followsCount = (res[0] && res[0].follows && res[0].follows.length) || 0;
      var followersCount = (res[1] && res[1].count) || 0;
      __fhMyFollowersCount = followersCount;
      var elF = document.getElementById('fhNetFollows');
      var elR = document.getElementById('fhNetFollowers');
      if(elF) elF.textContent = followsCount;
      if(elR) elR.textContent = followersCount;
      var hint = document.getElementById('fhNetHint');
      if(hint){
        if(followersCount > 0){
          hint.innerHTML = followersCount === 1
            ? '&#x1F31F; <b>1 Frogger</b> segue le tue attivita\'. Proponi giochi per farne di piu\'.'
            : '&#x1F31F; <b>' + followersCount + ' Frogger</b> seguono le tue attivita\'. Proponi giochi per farne di piu\'.';
        } else if(followsCount === 0){
          hint.textContent = 'Segui altri Frogger dalla 🏆 Classifica per vedere le loro proposte in evidenza sul catalogo.';
        } else {
          hint.textContent = 'Segui ' + followsCount + ' ' + (followsCount === 1 ? 'Frogger' : 'Frogger') + '. Le loro nuove proposte appariranno in evidenza sul catalogo.';
        }
      }
    }).catch(function(){});
  }

  function renderNickname(){
    var val = document.getElementById('fhNickValue');
    var optin = document.getElementById('fhNickOptin');
    var hint = document.getElementById('fhNickHint');
    if(val) val.textContent = __fhNickState.current || '—';
    if(optin) optin.checked = __fhNickState.publicOptIn;
    if(hint){
      if(__fhNickState.publicOptIn){
        hint.textContent = '🌐 Nickname pubblico — visibile nella classifica dei Frogger. Togli la spunta per nasconderti.';
        hint.classList.add('is-public');
      } else {
        hint.textContent = '🔒 Nascosto dalla classifica — nessuno vede il tuo nickname. Rimetti la spunta per tornare pubblico.';
        hint.classList.remove('is-public');
      }
    }
  }

  function initNicknameUI(){
    var display = document.getElementById('fhNickDisplay');
    var edit = document.getElementById('fhNickEdit');
    var input = document.getElementById('fhNickInput');
    var editBtn = document.getElementById('fhNickEditBtn');
    var saveBtn = document.getElementById('fhNickSave');
    var cancelBtn = document.getElementById('fhNickCancel');
    var err = document.getElementById('fhNickErr');
    var optin = document.getElementById('fhNickOptin');
    if(!display || display._nickWired) return;
    display._nickWired = true;

    function showErr(msg){ if(err){ err.hidden = false; err.textContent = msg; } }
    function clearErr(){ if(err){ err.hidden = true; err.textContent = ''; } }

    function startEdit(){
      clearErr();
      display.hidden = true; edit.hidden = false;
      input.value = __fhNickState.current || '';
      input.focus(); input.select();
    }
    function stopEdit(){ edit.hidden = true; display.hidden = false; clearErr(); }

    if(editBtn) editBtn.addEventListener('click', startEdit);
    if(cancelBtn) cancelBtn.addEventListener('click', stopEdit);
    if(saveBtn) saveBtn.addEventListener('click', function(){
      var newNick = (input.value || '').trim();
      if(!newNick){ showErr('Il nickname non puo\' essere vuoto'); return; }
      var cid = (window.__frogHunt && window.__frogHunt.customerId) || null;
      if(!cid) return;
      saveBtn.disabled = true;
      fetch(WORKER_URL + '/api/frogger/profile', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ customerId: String(cid), action: 'update', nickname: newNick })
      }).then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
        .then(function(res){
          saveBtn.disabled = false;
          if(!res.ok || (res.d && res.d.error)){
            showErr(res.d.error || 'Errore salvataggio');
            return;
          }
          __fhNickState.current = res.d.profile.nickname;
          renderNickname();
          stopEdit();
          // Conferma visiva: toast + flash verde sul valore
          if(typeof showToast === 'function') showToast('✓ Nickname salvato: ' + res.d.profile.nickname, 'success');
          var val = document.getElementById('fhNickValue');
          if(val){
            val.classList.add('is-flashing');
            setTimeout(function(){ val.classList.remove('is-flashing'); }, 1200);
          }
        }).catch(function(){ saveBtn.disabled = false; showErr('Errore di rete'); });
    });
    if(input) input.addEventListener('keydown', function(e){
      if(e.key === 'Enter') saveBtn.click();
      else if(e.key === 'Escape') stopEdit();
    });
    if(optin) optin.addEventListener('change', function(){
      var cid = (window.__frogHunt && window.__frogHunt.customerId) || null;
      if(!cid) return;
      var newVal = !!optin.checked;
      fetch(WORKER_URL + '/api/frogger/profile', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ customerId: String(cid), action: 'update', publicOptIn: newVal })
      }).then(function(r){ return r.json(); }).then(function(d){
        if(d && d.profile){
          __fhNickState.publicOptIn = !!d.profile.publicOptIn;
          renderNickname();
          if(typeof showToast === 'function'){
            showToast(newVal ? '🌐 Tornato nella classifica pubblica' : '🔒 Nascosto dalla classifica', 'success');
          }
        }
      }).catch(function(){
        optin.checked = !newVal;
        if(typeof showToast === 'function') showToast('Errore di rete', 'error');
      });
    });
  }

  // Sticky CTA mobile: mostra dopo 400ms se non dismesso in localStorage
  function initStickyCta(){
    var cta = document.getElementById('fhCtaSticky');
    var closeBtn = document.getElementById('fhCtaStickyClose');
    if(!cta) return;
    var KEY = 'fh_cta_dismissed';
    try { if(localStorage.getItem(KEY) === '1') return; } catch(_){}
    setTimeout(function(){
      cta.hidden = false;
      document.body.classList.add('fh-cta-visible');
    }, 450);
    cta.addEventListener('click', function(e){
      if(e.target === closeBtn) return;
      var propBtn = document.getElementById('fhProposeCta');
      if(propBtn) propBtn.click();
    });
    if(closeBtn){
      closeBtn.addEventListener('click', function(e){
        e.stopPropagation();
        cta.hidden = true;
        document.body.classList.remove('fh-cta-visible');
        try { localStorage.setItem(KEY, '1'); } catch(_){}
      });
    }
  }

  // Rail dots + counter + is-visible sync per ogni rail
  function initRailIndicators(){
    document.querySelectorAll('.fh-rail__track').forEach(function(track){
      if(track._indic) return; track._indic = true;
      var trackId = track.id;
      if(!trackId) return;
      var dotsEl = document.getElementById(trackId + 'Dots');
      var counterEl = document.getElementById(trackId + 'Counter');

      function refresh(){
        var cards = track.querySelectorAll('.fh-rcard');
        var total = cards.length;
        if(!total){
          if(dotsEl) dotsEl.innerHTML = '';
          if(counterEl){ counterEl.hidden = true; }
          return;
        }
        // Card visibili per pagina (approssimato)
        var perPage = Math.max(1, Math.floor(track.clientWidth / (cards[0].clientWidth + 14)));
        var pages = Math.max(1, Math.ceil(total / perPage));
        var currentPage = Math.round(track.scrollLeft / (track.clientWidth * 0.85));
        if(currentPage >= pages) currentPage = pages - 1;
        if(currentPage < 0) currentPage = 0;

        // Counter "N giochi"
        if(counterEl){
          counterEl.hidden = false;
          counterEl.textContent = total + ' ' + (total === 1 ? t('gioco', 'gioco') : t('giochi', 'giochi'));
        }

        // Dots: solo se più di 1 pagina, max 8 dots
        if(dotsEl){
          if(pages <= 1){
            dotsEl.innerHTML = '';
          } else {
            var maxDots = Math.min(pages, 8);
            var html = '';
            for(var i = 0; i < maxDots; i++){
              var active = i === Math.min(currentPage, maxDots - 1) ? ' is-active' : '';
              html += '<button type="button" class="fh-rail__dot' + active + '" data-page="' + i + '" aria-label="Pagina ' + (i+1) + '"></button>';
            }
            dotsEl.innerHTML = html;
            dotsEl.querySelectorAll('.fh-rail__dot').forEach(function(dot){
              dot.addEventListener('click', function(){
                var p = parseInt(dot.getAttribute('data-page'), 10) || 0;
                track.scrollTo({ left: p * track.clientWidth * 0.85, behavior: 'smooth' });
              });
            });
          }
        }
      }
      track.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      // MutationObserver: rifresh quando arrivano nuove card
      var mo = new MutationObserver(refresh);
      mo.observe(track, { childList: true });
      setTimeout(refresh, 60);
    });
  }

  // Tab switcher: 1 solo rail visibile, click sui tab per cambiare
  function initTabRail(){
    var wrap = document.getElementById('fhTabrail');
    if(!wrap || wrap._init) return; wrap._init = true;
    var tabs = wrap.querySelectorAll('[data-tabrail-tab]');
    var panels = wrap.querySelectorAll('[data-tabrail-panel]');
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var key = tab.getAttribute('data-tabrail-tab');
        tabs.forEach(function(t){
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function(p){
          p.classList.toggle('is-active', p.getAttribute('data-tabrail-panel') === key);
        });
        // Ricalcola dots/counter del rail appena reso visibile
        var activePanel = wrap.querySelector('[data-tabrail-panel="' + key + '"]');
        if(activePanel){
          var track = activePanel.querySelector('.fh-rail__track');
          if(track){ window.dispatchEvent(new Event('resize')); }
        }
      });
    });
  }

  // Shell: sidebar sempre visibile per loggati (per widget classifica, anche senza hunt personali)
  function updateShellLayout(hasMine){
    var shell = document.getElementById('fhShell');
    var aside = document.getElementById('fhMineAside');
    var fab = document.getElementById('fhMineFab');
    var isLogged = !!(window.__frogHunt && window.__frogHunt.customerId);
    if(!shell) return;
    if(hasMine || isLogged){
      shell.classList.remove('fh-shell--nomine');
      if(aside) aside.hidden = false;
      if(fab) fab.hidden = !hasMine; // FAB solo se ha hunt (altrimenti bottom-sheet vuoto sarebbe strano)
    } else {
      shell.classList.add('fh-shell--nomine');
      if(aside) aside.hidden = true;
      if(fab) fab.hidden = true;
    }
  }

  // Widget sidebar "Dai tuoi seguiti" — hunt proposte dai Frogger che segui + counter NEW
  var LS_NETWORK_SEEN = 'fh_network_last_seen';
  function getNetworkLastSeen(){
    try { return parseInt(localStorage.getItem(LS_NETWORK_SEEN) || '0', 10) || 0; } catch(_){ return 0; }
  }
  function markNetworkSeen(){
    try { localStorage.setItem(LS_NETWORK_SEEN, String(Date.now())); } catch(_){}
    var widget = document.getElementById('fhMineWidgetNetwork');
    var pill = document.getElementById('fhNewPill');
    if(widget) widget.classList.remove('has-new');
    if(pill) pill.hidden = true;
    var countEl = document.getElementById('fhMineNetworkCount');
    // Rimuovi suffisso "(N NEW)" dal count
    if(countEl && /\(/.test(countEl.textContent)) countEl.textContent = countEl.textContent.replace(/\s*\(.*?\)$/, '');
    // Rimuovi is-new dalle righe
    if(widget) widget.querySelectorAll('.fh-mrow.is-new').forEach(function(r){ r.classList.remove('is-new'); });
  }

  function loadMyNetworkHunts(){
    var cid = (window.__frogHunt && window.__frogHunt.customerId) || null;
    if(!cid) return;
    var widget = document.getElementById('fhMineWidgetNetwork');
    var listEl = document.getElementById('fhMineListNetwork');
    var countEl = document.getElementById('fhMineNetworkCount');
    if(!widget || !listEl) return;

    fetch(WORKER_URL + '/api/frogger/my-network-hunts?customerId=' + encodeURIComponent(cid), { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(d){
        var hunts = (d && d.hunts) || [];
        if(!hunts.length){
          widget.hidden = true;
          return;
        }
        widget.hidden = false;

        var lastSeen = getNetworkLastSeen();
        var newCount = 0;
        // Prima visita (lastSeen === 0): NON marchiamo nulla come new, altrimenti tutto sarebbe NEW al primo login
        if(lastSeen > 0){
          newCount = hunts.filter(function(h){
            var t = h.proposedAt ? new Date(h.proposedAt).getTime() : 0;
            return t > lastSeen;
          }).length;
        } else {
          // Prima volta: silenzia (imposta lastSeen a now così i futuri contano davvero)
          markNetworkSeen();
        }

        if(countEl) countEl.textContent = hunts.length + (newCount > 0 ? ' (' + newCount + ' NEW)' : '');
        widget.classList.toggle('has-new', newCount > 0);

        // Mostra pill in cima al catalogo se ci sono novita'
        var pill = document.getElementById('fhNewPill');
        var pillTxt = document.getElementById('fhNewPillText');
        if(pill && pillTxt){
          if(newCount > 0){
            pill.hidden = false;
            pillTxt.textContent = newCount === 1
              ? t('una_nuova', 'Una nuova hunt dai tuoi seguiti \u2014 vedi')
              : newCount + t('nuove', ' nuove hunt dai tuoi seguiti \u2014 vedi');
          } else {
            pill.hidden = true;
          }
        }

        var statusLabels = { proposed:t('s_nuovo','Nuovo'), searching:t('s_ricerca','In ricerca'), ordered:t('s_ordinato','Ordinato'), found:t('s_trovato','Trovato'), out_of_print:t('s_fuori','Fuori catalogo'), unavailable:t('s_fuori','Fuori catalogo') };
        listEl.innerHTML = hunts.map(function(h){
          var img = h.image ? 'https://wsrv.nl/?url=' + encodeURIComponent(h.image) + '&w=120&h=160&fit=cover&output=webp&q=80' : '';
          var cleanName = decodeHtmlEntities(h.name);
          var statusTxt = statusLabels[h.status] || h.status;
          var t = h.proposedAt ? new Date(h.proposedAt).getTime() : 0;
          var isNew = lastSeen > 0 && t > lastSeen;
          return '<button type="button" class="fh-mrow' + (isNew ? ' is-new' : '') + '" data-mrow-slug="' + h.slug + '">' +
            '<div class="fh-mrow__thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="fh-mrow__body">' +
              '<p class="fh-mrow__name">' + escHtml(cleanName) + '</p>' +
              '<div class="fh-mrow__meta">👤 <b>' + escHtml(h.proposerNickname) + '</b> · 👥 ' + h.froggerCount + '</div>' +
            '</div>' +
            '<span class="fh-mrow__status fh-mrow__status--' + h.status + '">' + statusTxt + '</span>' +
          '</button>';
        }).join('');

        // Click su riga → mark as seen + apri modal dettaglio
        listEl.querySelectorAll('[data-mrow-slug]').forEach(function(row){
          row.addEventListener('click', function(){
            markNetworkSeen();
            var slug = row.getAttribute('data-mrow-slug');
            if(slug && typeof openDetailModal === 'function') openDetailModal(slug);
          });
        });

        // Mark as seen anche quando widget entra in viewport
        if(window.IntersectionObserver && !widget._seenObserver){
          var io = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              if(entry.isIntersecting) { markNetworkSeen(); io.disconnect(); }
            });
          }, { threshold: 0.5 });
          io.observe(widget);
          widget._seenObserver = io;
        }
      }).catch(function(){});
  }

  // Pill notifica in cima al catalogo: click → scroll al widget (desktop) o apri sheet (mobile)
  function initNewPill(){
    var pill = document.getElementById('fhNewPill');
    if(!pill || pill._b) return;
    pill._b = true;
    pill.addEventListener('click', function(){
      var isMobile = window.innerWidth < 1024;
      if(isMobile){
        // Apri bottom-sheet sidebar
        var fab = document.getElementById('fhMineFab');
        if(fab) fab.click();
      } else {
        // Scroll al widget desktop
        var widget = document.getElementById('fhMineWidgetNetwork');
        if(widget) widget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      markNetworkSeen();
    });
  }

  // Classifica Frogger (Step 3) — MODAL con 4 tab (Catalizzatori / Rabdomanti / Nuovi Talenti / Riferimenti)
  var __fhBoardMyFollows = new Set();
  var __fhFollowedNicknames = {}; // cid → nickname (dei Frogger che seguo, per badge card)
  var __fhMyFollowersCount = 0;   // quanti Frogger mi seguono
  var __fhBoardCache = {}; // { catalyst: [...], sniper: [...], fresh: [...], influencer: [...] }
  var __fhBoardCurrentTab = 'catalyst';
  var __fhBoardTabInfo = {
    catalyst:   { sub: 'I Frogger che portano più community sulle proprie proposte.' },
    sniper:     { sub: 'Miglior percentuale di hunt trovate — chi ha buon fiuto (min 3 proposte).' },
    fresh:      { sub: 'Nuovi talenti attivi negli ultimi 30 giorni — dai spazio a chi entra.' },
    influencer: { sub: 'I Frogger che la community sceglie di seguire — chi ha almeno 1 follower.' }
  };

  function initBoardModal(){
    var openBtn = document.getElementById('fhBoardOpenBtn');
    var modal = document.getElementById('fhBoardModal');
    var closeBtn = document.getElementById('fhBoardModalClose');
    if(!modal || !openBtn || openBtn._b) return;
    openBtn._b = true;
    function open(){
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      loadLeaderboard(__fhBoardCurrentTab);
    }
    function close(){
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    openBtn.addEventListener('click', open);
    if(closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function(e){ if(e.target === modal) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && modal.classList.contains('is-open')) close(); });

    // Tab switcher
    modal.querySelectorAll('[data-btab]').forEach(function(tabBtn){
      tabBtn.addEventListener('click', function(){
        var tab = tabBtn.getAttribute('data-btab');
        modal.querySelectorAll('[data-btab]').forEach(function(b){ b.classList.remove('is-active'); });
        tabBtn.classList.add('is-active');
        __fhBoardCurrentTab = tab;
        var sub = document.getElementById('fhBoardModalSub');
        if(sub && __fhBoardTabInfo[tab]) sub.textContent = __fhBoardTabInfo[tab].sub;
        loadLeaderboard(tab);
      });
    });
  }

  function renderTopbar(list){
    var bar = document.getElementById('fhTopbar');
    var listEl = document.getElementById('fhTopbarList');
    if(!bar || !listEl || !list || !list.length) return;
    bar.hidden = false;
    var myCid = String((window.__frogHunt && window.__frogHunt.customerId) || '');
    listEl.innerHTML = list.slice(0, 3).map(function(item, i){
      var rank = i + 1;
      var mark = rank === 1 ? '🥇' : rank === 2 ? '🥈' : '🥉';
      var initial = (item.nickname || '?').charAt(0).toUpperCase();
      var isMe = String(item.customerId) === myCid;
      return '<button type="button" class="fh-topbar__item' + (isMe ? ' is-me' : '') + '" data-topbar-cid="' + item.customerId + '" title="' + escHtml(item.nickname) + ' ha portato ' + (item.froggersBrought || item.score || 0) + ' Frogger">' +
        '<span class="fh-topbar__rank">' + mark + '</span>' +
        '<span class="fh-topbar__avatar">' + escHtml(initial) + '</span>' +
        '<span class="fh-topbar__nick">' + escHtml(item.nickname) + '</span>' +
        '<span class="fh-topbar__score">&#x1F465; ' + (item.froggersBrought || item.score || 0) + '</span>' +
      '</button>';
    }).join('');
    // Click su un top Frogger → apre modal classifica direttamente su Catalizzatori
    listEl.querySelectorAll('[data-topbar-cid]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var openBtn = document.getElementById('fhBoardOpenBtn');
        if(openBtn) openBtn.click();
        // Espande automaticamente la riga cliccata dopo che il modal è aperto
        setTimeout(function(){
          var targetCid = btn.getAttribute('data-topbar-cid');
          var row = document.querySelector('.fh-bm-row[data-bm-cid="' + targetCid + '"]');
          if(row && !row.classList.contains('is-expanded')){
            toggleBoardRow(row);
            row.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 250);
      });
    });
  }

  function initTopbarCta(){
    var cta = document.getElementById('fhTopbarCta');
    var openBtn = document.getElementById('fhBoardOpenBtn');
    if(!cta || !openBtn || cta._b) return;
    cta._b = true;
    cta.addEventListener('click', function(){ openBtn.click(); });
  }

  function loadLeaderboard(tab){
    tab = tab || 'catalyst';
    var body = document.getElementById('fhBoardModalBody');
    // Se cache pronta → render immediato (nessun flash)
    if(__fhBoardCache[tab]) {
      renderLeaderboard(__fhBoardCache[tab], tab);
      if(tab === 'catalyst') renderTopbar(__fhBoardCache[tab]);
      return;
    }
    // Se il modal è aperto e c'è già contenuto (altra tab): NON wipe, solo fade
    if(body){
      var hasContent = body.querySelector('.fh-bm-row') !== null;
      if(hasContent){
        body.classList.add('is-loading'); // opacity 0.5 via CSS
      } else {
        body.innerHTML = '<div class="fh-board__empty">Caricamento&hellip;</div>';
      }
    }
    var cid = (window.__frogHunt && window.__frogHunt.customerId) || null;
    Promise.all([
      fetch(WORKER_URL + '/api/frogger/leaderboard?type=' + tab, { cache: 'no-store' }).then(function(r){ return r.json(); }),
      cid ? fetch(WORKER_URL + '/api/frogger/my-follows?customerId=' + encodeURIComponent(cid), { cache: 'no-store' }).then(function(r){ return r.json(); }) : Promise.resolve({follows:[]})
    ]).then(function(res){
      var board = (res[0] && res[0].leaderboard) || [];
      var follows = (res[1] && res[1].follows) || [];
      __fhBoardMyFollows = new Set(follows.map(String));
      __fhBoardCache[tab] = board;
      if(body) body.classList.remove('is-loading');
      // Renderizza solo se il tab richiesto è ancora quello attivo (evita race con click veloci)
      if(__fhBoardCurrentTab === tab) renderLeaderboard(board, tab);
      // Hero strip usa sempre catalyst (top per Frogger portati)
      if(tab === 'catalyst') renderTopbar(board);
      preloadTopDetails(board.slice(0, 5));
      // Fase A: risolvi nickname dei Frogger che seguo per badge "Da X che segui" sulle card
      if(follows.length){
        // 1) nickname già presenti nel leaderboard cachato
        board.forEach(function(item){
          if(follows.indexOf(String(item.customerId)) !== -1) __fhFollowedNicknames[String(item.customerId)] = item.nickname;
        });
        // 2) bulk fetch per i seguiti NON in top 20
        var missing = follows.filter(function(f){ return !__fhFollowedNicknames[String(f)]; });
        if(missing.length){
          fetch(WORKER_URL + '/api/frogger/nicknames?cids=' + encodeURIComponent(missing.join(',')), { cache: 'no-store' })
            .then(function(r){ return r.json(); })
            .then(function(d){
              if(d && d.nicknames){
                Object.keys(d.nicknames).forEach(function(cid){ __fhFollowedNicknames[cid] = d.nicknames[cid]; });
                if(typeof renderCatalog === 'function') renderCatalog();
              }
            }).catch(function(){});
        } else if(typeof renderCatalog === 'function'){
          renderCatalog();
        }
      }
    }).catch(function(){
      if(body){
        body.classList.remove('is-loading');
        if(!body.querySelector('.fh-bm-row')) body.innerHTML = '<div class="fh-board__empty">Errore di caricamento — riprova.</div>';
      }
    });
  }

  var __fhDetailPreloadDone = new Set();
  function preloadTopDetails(list){
    if(!list || !list.length) return;
    list.forEach(function(item){
      var cid = String(item.customerId);
      if(__fhDetailPreloadDone.has(cid)) return;
      __fhDetailPreloadDone.add(cid);
      // Fire-and-forget: popola la cache backend (10 min)
      fetch(WORKER_URL + '/api/frogger/detail?cid=' + encodeURIComponent(cid), { cache: 'no-store' }).catch(function(){});
    });
  }

  function renderLeaderboard(list, tab){
    tab = tab || 'catalyst';
    var body = document.getElementById('fhBoardModalBody');
    if(!body) return;

    if(!list.length){
      var emptyMsg = tab === 'sniper' ? 'Serve almeno 1 Frogger con 3+ proposte trovate. Presto ci sara\'.'
        : tab === 'fresh' ? 'Ancora nessun nuovo talento attivo negli ultimi 30gg. Proponi tu il primo gioco!'
        : tab === 'influencer' ? 'Ancora nessun Frogger seguito. Sii il primo a seguire un Catalizzatore per aprire la classifica.'
        : 'Nessun Frogger nella classifica ancora. Proponi il primo gioco!';
      body.innerHTML = '<div class="fh-board__empty">' + emptyMsg + '</div>';
      return;
    }

    var myCid = String((window.__frogHunt && window.__frogHunt.customerId) || '');
    body.innerHTML = list.slice(0, 20).map(function(item, i){
      var rank = i + 1;
      var isMe = String(item.customerId) === myCid;
      var isFollowing = __fhBoardMyFollows.has(String(item.customerId));
      var initial = (item.nickname || '?').charAt(0).toUpperCase();
      var btnClass = isMe ? 'fh-bm-row__follow is-me' : (isFollowing ? 'fh-bm-row__follow is-following' : 'fh-bm-row__follow');
      var btnLabel = isMe ? 'Tu' : (isFollowing ? '✓ Segui' : t('piu_segui', '+ Segui'));
      var rankMark = rank === 1 ? '🥇' : rank === 2 ? '🥈' : rank === 3 ? '🥉' : rank;

      // Meta contestuale al tab
      var metaHtml;
      if(tab === 'sniper'){
        metaHtml = '<b>' + item.hitCount + '</b> trovati su <b>' + item.proposeCount + '</b> proposte · <b>' + item.hitRate + '%</b>';
      } else if(tab === 'fresh'){
        var days = item.activeDaysSince;
        var when = days < 30 ? days + ' giorni' : Math.round(days / 30) + ' mesi';
        metaHtml = 'Attivo da <b>' + when + '</b> · <b>' + item.recentFroggers + '</b> Frogger portati (30gg)';
      } else if(tab === 'influencer'){
        var fCount = item.followerCount || 0;
        var word = fCount === 1 ? 'Frogger lo segue' : 'Frogger lo seguono';
        metaHtml = '<b>' + fCount + '</b> ' + word + ' · <b>' + item.proposeCount + '</b> proposte · <b>' + item.froggersBrought + '</b> Frogger portati';
      } else {
        var huntsWord = item.proposeCount === 1 ? 'gioco' : 'giochi';
        var froggersWord = item.froggersBrought === 1 ? 'Frogger si e\' unito' : 'Frogger si sono uniti';
        metaHtml = 'Ha proposto <b>' + item.proposeCount + '</b> ' + huntsWord + ' · <b>' + item.froggersBrought + '</b> ' + froggersWord;
      }

      return '<div class="fh-bm-row' + (isMe ? ' is-me' : '') + '" data-bm-cid="' + item.customerId + '">' +
        '<div class="fh-bm-row__head">' +
          '<span class="fh-bm-row__rank' + (rank <= 3 ? ' is-top' : '') + '">' + rankMark + '</span>' +
          '<span class="fh-bm-row__avatar">' + escHtml(initial) + '</span>' +
          '<div class="fh-bm-row__body">' +
            '<span class="fh-bm-row__nick">' + escHtml(item.nickname) + '</span>' +
            '<div class="fh-bm-row__meta">' + metaHtml + '</div>' +
          '</div>' +
          '<div class="fh-bm-row__actions">' +
            '<button type="button" class="' + btnClass + '" data-bm-follow="' + item.customerId + '"' + (isMe ? ' disabled' : '') + '>' + btnLabel + '</button>' +
            '<span class="fh-bm-row__chev" data-bm-toggle>▾</span>' +
          '</div>' +
        '</div>' +
        '<div class="fh-bm-row__detail"><div class="fh-bm-row__loading">Caricamento&hellip;</div></div>' +
      '</div>';
    }).join('');

    // Wire expand + follow
    body.querySelectorAll('.fh-bm-row').forEach(function(row){
      var head = row.querySelector('.fh-bm-row__head');
      var followBtn = row.querySelector('[data-bm-follow]');
      var toggle = row.querySelector('[data-bm-toggle]');
      if(head){
        head.addEventListener('click', function(e){
          if(e.target.closest('[data-bm-follow]')) return; // click sul follow non toggle
          toggleBoardRow(row);
        });
      }
      if(followBtn){
        followBtn.addEventListener('click', function(e){
          e.stopPropagation();
          var targetCid = followBtn.getAttribute('data-bm-follow');
          toggleFollowFrogger(targetCid, followBtn);
        });
      }
    });
  }

  function toggleBoardRow(row){
    var wasOpen = row.classList.contains('is-expanded');
    // close all others
    document.querySelectorAll('.fh-bm-row.is-expanded').forEach(function(r){ if(r !== row) r.classList.remove('is-expanded'); });
    if(wasOpen){ row.classList.remove('is-expanded'); return; }
    row.classList.add('is-expanded');
    // Lazy load detail
    var detail = row.querySelector('.fh-bm-row__detail');
    if(detail && !detail._loaded){
      detail._loaded = true;
      var cid = row.getAttribute('data-bm-cid');
      fetch(WORKER_URL + '/api/frogger/detail?cid=' + encodeURIComponent(cid), { cache: 'no-store' })
        .then(function(r){ return r.json(); })
        .then(function(d){
          if(!d || d.error){ detail.innerHTML = '<div class="fh-board__empty">' + escHtml(d && d.error || 'Errore') + '</div>'; return; }

          var myCid = String((window.__frogHunt && window.__frogHunt.customerId) || '');
          var targetCid = row.getAttribute('data-bm-cid');
          var isMeRow = String(targetCid) === myCid;
          var isFollowingRow = __fhBoardMyFollows.has(String(targetCid));

          var s = d.stats || {};

          // === KPI tiles (3 numeri grandi) ===
          var kpisHtml = '<div class="fh-bm-kpis">' +
            '<div class="fh-bm-kpi"><b>' + (s.proposeCount || 0) + '</b><span>hunt proposte</span></div>' +
            '<div class="fh-bm-kpi fh-bm-kpi--found"><b>' + (s.hitCount || 0) + '</b><span>gia\' trovati</span><em>' + (s.hitRate || 0) + '%</em></div>' +
            '<div class="fh-bm-kpi fh-bm-kpi--pack"><b>' + (s.froggersBrought || 0) + '</b><span>Frogger uniti</span></div>' +
          '</div>';

          // === Highlights (attivo da, best hit, top categorie) ===
          var highlights = [];
          if(s.activeDaysSince){
            var when = s.activeDaysSince < 30 ? s.activeDaysSince + ' giorni'
              : s.activeDaysSince < 365 ? Math.round(s.activeDaysSince / 30) + ' mesi'
              : Math.round(s.activeDaysSince / 365 * 10) / 10 + ' anni';
            highlights.push('<div class="fh-bm-hl"><span class="fh-bm-hl__ico">🎯</span><span>Attivo da <b>' + when + '</b></span></div>');
          }
          if(d.bestHit){
            highlights.push('<div class="fh-bm-hl"><span class="fh-bm-hl__ico">🏆</span><span>Miglior proposta: <b>' + escHtml(d.bestHit.name) + '</b> &mdash; <b>' + d.bestHit.froggerCount + '</b> Frogger</span></div>');
          }
          if(d.topCategories && d.topCategories.length){
            var cats = d.topCategories.map(function(c){ return escHtml(c.name); }).join(' &middot; ');
            highlights.push('<div class="fh-bm-hl"><span class="fh-bm-hl__ico">🎨</span><span>Ama: <b>' + cats + '</b></span></div>');
          }
          if(d.topMechanics && d.topMechanics.length && !d.topCategories.length){
            var mechs = d.topMechanics.slice(0,2).map(function(m){ return escHtml(m.name); }).join(' &middot; ');
            highlights.push('<div class="fh-bm-hl"><span class="fh-bm-hl__ico">⚙</span><span>Meccaniche: <b>' + mechs + '</b></span></div>');
          }
          var highlightsHtml = highlights.length ? '<div class="fh-bm-hls">' + highlights.join('') + '</div>' : '';

          // === Follow CTA prominente (solo per altri) ===
          var followBlockHtml = '';
          if(!isMeRow){
            var followCta = isFollowingRow
              ? '<button type="button" class="fh-bm-followcta is-following" data-bm-followcta="' + targetCid + '">&#x2713; Lo stai seguendo &mdash; clicca per smettere</button>'
              : '<button type="button" class="fh-bm-followcta" data-bm-followcta="' + targetCid + '">&#x1F517; Segui ' + escHtml(d.nickname) + ' &mdash; ti avviseremo alle prossime richieste</button>';
            followBlockHtml = '<div class="fh-bm-row__section fh-bm-row__section--cta">' + followCta + '</div>';
          }

          // === Hunt proposte (top 5 con status badge inline) ===
          var STATUS_MAP = {
            proposed:  {t:t('s_nuovo','Nuovo'),       c:'#EDE9FE', k:'#5B21B6'},
            searching: {t:t('s_ricerca','In ricerca'),  c:'#FEF3C7', k:'#92400E'},
            ordered:   {t:t('s_ordinato','Ordinato'),    c:'#DBEAFE', k:'#1E40AF'},
            found:     {t:t('s_trovato','Trovato'),     c:'#D1FAE5', k:'#065F46'},
            out_of_print:{t:t('s_fuori_br','Fuori cat.'),c:'#F1F5F9', k:'#64748B'},
            unavailable:{t:t('s_fuori_br','Fuori cat.'), c:'#F1F5F9', k:'#64748B'}
          };
          function huntRowHtml(h){
            var img = h.image ? 'https://wsrv.nl/?url=' + encodeURIComponent(h.image) + '&w=60&h=80&fit=cover&output=webp&q=80' : '';
            var st = STATUS_MAP[h.status] || STATUS_MAP.proposed;
            return '<a class="fh-bm-hunt" href="/pages/froghunt?hunt=' + encodeURIComponent(h.slug) + '">' +
              '<div class="fh-bm-hunt__thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
              '<span class="fh-bm-hunt__name">' + escHtml(h.name) + '</span>' +
              '<span class="fh-bm-hunt__st" style="background:' + st.c + ';color:' + st.k + '">' + st.t + '</span>' +
              '<span class="fh-bm-hunt__froggers">🐸 ' + (h.froggerCount || 0) + '</span>' +
            '</a>';
          }
          var propList = (d.proposed || []).map(huntRowHtml).join('');
          var propMore = d.proposedTotal > 5
            ? '<div class="fh-bm-hunt__more">+ altre ' + (d.proposedTotal - 5) + t('hunt_proposte', ' hunt proposte') + '</div>'
            : '';
          var propHtml = propList
            ? propList + propMore
            : '<div class="fh-board__empty" style="padding:.5rem">Nessuna proposta.</div>';

          var followList = (d.following || []).map(huntRowHtml).join('');
          var followMore = d.followingTotal > 5
            ? '<div class="fh-bm-hunt__more">+ altre ' + (d.followingTotal - 5) + t('hunt_seguite', ' hunt seguite') + '</div>'
            : '';
          var followHtml = followList
            ? followList + followMore
            : '<div class="fh-board__empty" style="padding:.5rem">Nessun gioco seguito.</div>';

          detail.innerHTML =
            kpisHtml +
            highlightsHtml +
            followBlockHtml +
            '<div class="fh-bm-row__section"><h5>🎲 Hunt proposte</h5>' + propHtml + '</div>' +
            '<div class="fh-bm-row__section"><h5>💚 Segue</h5>' + followHtml + '</div>';

          // Wire follow CTA prominente
          var bigBtn = detail.querySelector('[data-bm-followcta]');
          if(bigBtn){
            bigBtn.addEventListener('click', function(e){
              e.stopPropagation();
              toggleFollowFrogger(bigBtn.getAttribute('data-bm-followcta'), bigBtn);
              // sync anche il piccolo bottone follow nella head
              var smallBtn = row.querySelector('[data-bm-follow]');
              if(smallBtn){
                if(__fhBoardMyFollows.has(String(targetCid))){
                  smallBtn.classList.add('is-following'); smallBtn.textContent = '✓ Segui';
                } else {
                  smallBtn.classList.remove('is-following'); smallBtn.textContent = t('piu_segui', '+ Segui');
                }
              }
              // aggiorna anche il testo del bottone grande
              setTimeout(function(){
                var nowFollowing = __fhBoardMyFollows.has(String(targetCid));
                if(nowFollowing){
                  bigBtn.classList.add('is-following');
                  bigBtn.innerHTML = '&#x2713; Lo stai seguendo &mdash; clicca per smettere';
                } else {
                  bigBtn.classList.remove('is-following');
                  bigBtn.innerHTML = '&#x1F517; Segui ' + escHtml(d.nickname) + ' &mdash; ti avviseremo alle prossime richieste';
                }
              }, 100);
            });
          }
        }).catch(function(){ detail.innerHTML = '<div class="fh-board__empty">Errore di rete</div>'; });
    }
  }

  function toggleFollowFrogger(targetCid, btn){
    var actor = String((window.__frogHunt && window.__frogHunt.customerId) || '');
    if(!actor || actor === 'null'){
      if(typeof showToast === 'function') showToast('Accedi per seguire i Frogger', 'error');
      return;
    }
    if(btn.classList.contains('is-me')) return;
    var isCurrentlyFollowing = btn.classList.contains('is-following');
    var endpoint = isCurrentlyFollowing ? '/api/frogger/unfollow' : '/api/frogger/follow';
    btn.disabled = true;
    fetch(WORKER_URL + endpoint, {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ actorId: actor, targetId: String(targetCid) })
    }).then(function(r){ return r.json(); }).then(function(d){
      btn.disabled = false;
      if(d && d.success){
        var scid = String(targetCid);
        if(d.following){
          __fhBoardMyFollows.add(scid);
          btn.classList.add('is-following');
          btn.textContent = '✓ Segui';
          if(typeof showToast === 'function') showToast('✓ Segui questo Frogger — vedrai le sue proposte in evidenza', 'success');
          // Live update: risolvo nickname + re-render catalog + topbar
          syncFollowLiveEffects(scid, true);
        } else {
          __fhBoardMyFollows.delete(scid);
          delete __fhFollowedNicknames[scid];
          btn.classList.remove('is-following');
          btn.textContent = t('piu_segui', '+ Segui');
          if(typeof showToast === 'function') showToast('Non segui piu\' questo Frogger', 'success');
          syncFollowLiveEffects(scid, false);
        }
      } else {
        if(typeof showToast === 'function') showToast((d && d.error) || 'Errore', 'error');
      }
    }).catch(function(){
      btn.disabled = false;
      if(typeof showToast === 'function') showToast('Errore di rete', 'error');
    });
  }

  // Live update dopo follow/unfollow: risolvi nickname, re-render catalog, aggiorna contatore modal
  function syncFollowLiveEffects(scid, isFollow){
    function afterNickReady(){
      if(typeof renderCatalog === 'function') renderCatalog();
      // Aggiorna contatore "Segui N" nel modal profilo se aperto
      var elF = document.getElementById('fhNetFollows');
      if(elF) elF.textContent = __fhBoardMyFollows.size;
      // Aggiorna hint contestuale nel modal profilo
      var hint = document.getElementById('fhNetHint');
      if(hint){
        var count = __fhBoardMyFollows.size;
        if(__fhMyFollowersCount > 0){
          hint.innerHTML = '&#x1F31F; <b>' + __fhMyFollowersCount + ' Frogger</b> ' + (__fhMyFollowersCount === 1 ? 'segue' : 'seguono') + ' le tue attivita\'. Proponi giochi per farne di piu\'.';
        } else if(count === 0){
          hint.textContent = 'Segui altri Frogger dalla 🏆 Classifica per vedere le loro proposte in evidenza sul catalogo.';
        } else {
          hint.textContent = 'Segui ' + count + ' Frogger. Le loro nuove proposte appariranno in evidenza sul catalogo.';
        }
      }
    }
    if(!isFollow || __fhFollowedNicknames[scid]) { afterNickReady(); loadMyNetworkHunts(); return; }
    // Fetch nickname del nuovo seguito
    fetch(WORKER_URL + '/api/frogger/nicknames?cids=' + encodeURIComponent(scid), { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(d && d.nicknames && d.nicknames[scid]) __fhFollowedNicknames[scid] = d.nicknames[scid];
        afterNickReady();
        loadMyNetworkHunts(); // refresh widget sidebar con nuove hunt del seguito
      }).catch(function(){ afterNickReady(); loadMyNetworkHunts(); });
  }

  // Notifica update non letto: confronto updatedAt con lastSeen in localStorage.
  // Fix: se lastSeen non esiste (mai visto) → NON è un update non letto (evita false-positive al primo login).
  // Alla prima visita "seen" viene inizializzato con updatedAt corrente → futuri cambi triggerano bell.
  // Ultima cosa successa su questa hunt: un cambio di stato OPPURE un commento.
  // I commenti stanno in una chiave separata e non toccano updatedAt: senza
  // lastCommentAt la campanella era cieca alle risposte, anche a quelle dell'admin.
  function huntTouchTs(h){
    var up = typeof h.updatedAt === 'number' ? h.updatedAt : Date.parse(h.updatedAt || 0);
    var cm = typeof h.lastCommentAt === 'number' ? h.lastCommentAt : Date.parse(h.lastCommentAt || 0);
    return Math.max(up || 0, cm || 0);
  }
  function hasUnreadUpdate(h){
    try {
      var seen = JSON.parse(localStorage.getItem('fh_lastseen') || '{}');
      var lastSeen = seen[h.slug];
      if(typeof lastSeen !== 'number' || lastSeen <= 0) return false; // mai visto → silenzioso, no rosso
      var ts = huntTouchTs(h);
      if(!ts) return false;
      return ts > lastSeen + 1000;
    } catch(_){ return false; }
  }
  // Che cosa e' cambiato: serve a dire "nuovo commento" invece di un generico "!"
  function unreadIsComment(h){
    var cm = typeof h.lastCommentAt === 'number' ? h.lastCommentAt : Date.parse(h.lastCommentAt || 0);
    if(!cm) return false;
    var up = typeof h.updatedAt === 'number' ? h.updatedAt : Date.parse(h.updatedAt || 0);
    return cm >= (up || 0);
  }
  // Inizializza lastSeen per hunt mai viste (silenzia le future finche' non arrivano update veri)
  function initSeenForNew(mine){
    try {
      var seen = JSON.parse(localStorage.getItem('fh_lastseen') || '{}');
      var changed = false;
      mine.forEach(function(h){
        if(typeof seen[h.slug] !== 'number'){
          seen[h.slug] = huntTouchTs(h) || Date.now();
          changed = true;
        }
      });
      if(changed) localStorage.setItem('fh_lastseen', JSON.stringify(seen));
    } catch(_){}
  }
  function markSeen(slug, ts){
    try {
      var seen = JSON.parse(localStorage.getItem('fh_lastseen') || '{}');
      seen[slug] = ts || Date.now();
      localStorage.setItem('fh_lastseen', JSON.stringify(seen));
    } catch(_){}
  }

  // Riga compatta della sidebar (usata dai 3 widget)
  function mrowHtml(h){
    var img = h.image || h.thumbnail || '';
    var imgSrc = img ? 'https://wsrv.nl/?url=' + encodeURIComponent(img) + '&w=120&h=160&fit=cover&output=webp&q=80' : '';
    var isBuyable = h.status === 'found' && h.purchasableSince && !h.purchasablePaused
      && h.shopifyProductUrl && typeof isValidShopUrl === 'function' && isValidShopUrl(h.shopifyProductUrl);
    var isPaused = h.status === 'found' && h.purchasablePaused;

    var statusLabels = { proposed:'Proposto', searching:'In ricerca', ordered:'Ordinato', found:'Trovato', out_of_print:'Fuori catalogo', unavailable:'Fuori catalogo' };
    var statusKey = isPaused ? 'paused' : h.status;
    var statusTxt = isPaused ? 'Esaurito' : (statusLabels[h.status] || h.status);

    var unread = hasUnreadUpdate(h);
    // Icona diversa per cosa diversa: un commento non e' un cambio di stato.
    var bell = '';
    if(unread){
      bell = unreadIsComment(h)
        ? '<span class="fh-mrow__bell fh-mrow__bell--comment" title="Nuovo commento">&#x1F4AC;</span>'
        : '<span class="fh-mrow__bell" title="Aggiornamento non letto">!</span>';
    }

    // Se l'ho gia' comprato non ha senso invitarmi a comprarlo: chip "Preso" e basta
    var presoDaMe = isPurchasedByMe(h.slug);
    var tailHtml = presoDaMe
      ? '<span class="fh-mrow__status fh-mrow__status--preso">' + t('preso', '\u2714 Preso') + '</span>'
      : (isBuyable
        ? '<a class="fh-mrow__buy" href="' + escHtml(h.shopifyProductUrl) + '" onclick="event.stopPropagation()">&rarr; Compra</a>'
        : '<span class="fh-mrow__status fh-mrow__status--' + statusKey + '">' + statusTxt + '</span>');

    // Mini chip situation + difficoltà nella meta row (visibile subito)
    var sitMini = '';
    if(h.situation === 'awaiting') sitMini = ' · <span style="background:#FED7AA;color:#7C2D12;padding:1px 6px;border-radius:6px;font-weight:800;font-size:.6rem">🕐 In arrivo</span>';
    else if(h.situation === 'ks_incoming') sitMini = ' · <span style="background:#EDE9FE;color:#5B21B6;padding:1px 6px;border-radius:6px;font-weight:800;font-size:.6rem">🚀 KS</span>';
    var diffMini = '';
    if(h.difficulty){
      var _DIFF_MINI = {easy:['🟢','#d1fae5','#065f46'],medium:['🟡','#fef3c7','#92400e'],hard:['🟠','#fed7aa','#9a3412'],very_hard:['🔴','#fee2e2','#991b1b'],impossible:['💎','#1f2937','#f4c430']};
      var _d = _DIFF_MINI[h.difficulty];
      if(_d) diffMini = ' · <span style="background:'+_d[1]+';color:'+_d[2]+';padding:1px 6px;border-radius:6px;font-weight:800;font-size:.6rem" title="Difficolta\' di reperimento">'+_d[0]+'</span>';
    }
    sitMini += diffMini;

    // ✕ solo sulle hunt chiuse: su quelle attive si esce dal modale (Ritira / Segui gia').
    // <span>, non <button>: la riga e' gia' un <button> e non si annidano.
    var isClosedRow = h.status === 'out_of_print' || h.status === 'unavailable' || (h.status === 'found' && !isBuyable);
    var xHtml = isClosedRow
      ? '<span class="fh-mrow__x" role="button" tabindex="0" data-mrow-x="' + h.slug + '" title="' + escHtml(t('togli_lista', 'Togli dalla mia lista')) + '" aria-label="' + escHtml(t('togli_lista', 'Togli dalla mia lista')) + '">&#x2715;</span>'
      : '';

    return '<button type="button" class="fh-mrow' + (isBuyable && !presoDaMe ? ' fh-mrow--buy' : '') + (unread ? ' has-update' : '') + '" data-mrow-slug="' + h.slug + '">' +
      '<div class="fh-mrow__thumb">' + (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="fh-mrow__body">' +
        '<p class="fh-mrow__name">' + escHtml(decodeHtmlEntities(h.name)) + '</p>' +
        '<div class="fh-mrow__meta">' + (h._isProposer ? '🥇' : '💚') + ' <b>' + (h._isProposer ? 'Tua' : 'Segui') + '</b> · 👥 ' + (h.froggerCount || 0) + sitMini + '</div>' +
      '</div>' +
      bell + tailHtml + xHtml +
    '</button>';
  }

  // Sidebar: split mine in 4 widget (Buy / Wait-restock / Active / Introvabili)
  function renderMineList(mine){
    // Silenzia la campanella per hunt mai viste (evita rossi al primo login)
    initSeenForNew(mine);

    var widgetBuy = document.getElementById('fhMineWidgetBuy');
    var widgetWait = document.getElementById('fhMineWidgetWait');
    var widgetActive = document.getElementById('fhMineWidgetActive');
    var widgetImp = document.getElementById('fhMineWidgetImp');
    var listBuy = document.getElementById('fhMineListBuy');
    var listWait = document.getElementById('fhMineListWait');
    var listActive = document.getElementById('fhMineListActive');
    var listImp = document.getElementById('fhMineListImp');
    var widgetGot = document.getElementById('fhMineWidgetGot');
    var listGot = document.getElementById('fhMineListGot');
    var empty = document.getElementById('fhMineEmpty');
    var fabCount = document.getElementById('fhMineFabCount');
    if(!listBuy || !listActive || !listImp) return;

    var buy = [], wait = [], active = [], imp = [], got = [];
    mine.forEach(function(h){
      // Gia' comprato da me: esce dai "Comprabili" (non ho piu' niente da fare) e
      // finisce nel gruppo Presi, in fondo, chiuso come gli introvabili.
      if(isPurchasedByMe(h.slug)){ got.push(h); return; }
      var isFound = h.status === 'found';
      var isBuyable = isFound && h.purchasableSince && !h.purchasablePaused;
      var isPaused = isFound && h.purchasablePaused;
      var isImp = h.status === 'out_of_print' || h.status === 'unavailable';
      if(isBuyable) buy.push(h);
      else if(isPaused) wait.push(h);
      else if(isImp) imp.push(h);
      else active.push(h);
    });
    got.sort(function(a,b){
      var ta = Date.parse(purchasedAtByMe(a.slug) || 0) || 0;
      var tb = Date.parse(purchasedAtByMe(b.slug) || 0) || 0;
      return tb - ta;   // l'ultimo comprato in cima al gruppo
    });

    function fill(section, list, items, countId){
      if(!section || !list) return;
      section.hidden = !items.length;
      list.innerHTML = items.map(mrowHtml).join('');
      var countEl = document.getElementById(countId);
      if(countEl) countEl.textContent = items.length;
    }
    fill(widgetBuy, listBuy, buy, 'fhMineBuyCount');
    fill(widgetWait, listWait, wait, 'fhMineWaitCount');
    fill(widgetActive, listActive, active, 'fhMineActiveCount');
    fill(widgetImp, listImp, imp, 'fhMineImpCount');
    fill(widgetGot, listGot, got, 'fhMineGotCount');

    if(fabCount) fabCount.textContent = mine.length;
    if(empty) empty.hidden = mine.length > 0;

    // Click su ogni riga → apre modal e marca "letto"
    document.querySelectorAll('#fhMineAside [data-mrow-slug]').forEach(function(row){
      if(row._b) return; row._b = true;
      row.addEventListener('click', function(e){
        if(e.target.closest('.fh-mrow__buy')) return;
        var xBtn = e.target.closest('.fh-mrow__x');
        if(xBtn){
          e.stopPropagation();
          var xslug = xBtn.getAttribute('data-mrow-x');
          var xh = mine.filter(function(x){ return x.slug === xslug; })[0];
          if(xslug && confirm(t('togli_lista_conferma', 'Togliere "{name}" dalla tua lista? La ricerca resta sul sito, semplicemente non la segui più.').replace('{name}', xh ? decodeHtmlEntities(xh.name) : ''))){
            unfollowHunt(xslug);
          }
          return;
        }
        var slug = row.getAttribute('data-mrow-slug');
        var h = mine.filter(function(x){ return x.slug === slug; })[0];
        if(h){
          markSeen(slug, huntTouchTs(h) + 2000);
          row.classList.remove('has-update');
          var b = row.querySelector('.fh-mrow__bell');
          if(b) b.remove();
        }
        if(slug && typeof openDetailModal === 'function') openDetailModal(slug);
      });
    });
  }

  // Catalogo grid: SEGMENTI curati (guidano il cliente) invece di filtri generici piatti
  var __fhCatState = { seg: 'hot', q: '' };
  var __fhAllHunts = [];

  // Definizioni segmenti: filtro + ordinamento + didascalia
  var CAT_SEGS = {
    hot: {
      icon: '🔥',
      caption: t('cap_hot', 'Le hunt con piu\' nuovi Frogger negli ultimi 7 giorni.'),
      filter: function(h){
        var dead = h.status === 'out_of_print' || h.status === 'unavailable';
        return !dead && (h.weeklyFroggerCount || 0) >= 1;
      },
      sort: function(a,b){
        var d = (b.weeklyFroggerCount||0) - (a.weeklyFroggerCount||0);
        return d !== 0 ? d : (b.froggerCount||0) - (a.froggerCount||0);
      },
      limit: 30
    },
    popular: {
      icon: '📈',
      caption: t('cap_pop', 'Le ricerche piu\' seguite di sempre — dove c\'e\' piu\' community.'),
      filter: function(h){
        var dead = h.status === 'out_of_print' || h.status === 'unavailable';
        return !dead && (h.froggerCount || 0) >= 2;
      },
      sort: function(a,b){ return (b.froggerCount||0) - (a.froggerCount||0); },
      limit: 40
    },
    new: {
      icon: '🆕',
      caption: t('cap_new', 'Le hunt appena proposte — le proposte dei Frogger che segui appaiono in cima.'),
      filter: function(h){ return h.status === 'proposed'; },
      sort: function(a,b){
        // Boost: hunt proposte da chi segui vanno in cima
        var aFollowed = __fhBoardMyFollows.has(String(a.proposedByCustomerId || '')) ? 1 : 0;
        var bFollowed = __fhBoardMyFollows.has(String(b.proposedByCustomerId || '')) ? 1 : 0;
        if(aFollowed !== bFollowed) return bFollowed - aFollowed;
        var ta = typeof a.proposedAt === 'number' ? a.proposedAt : Date.parse(a.proposedAt || 0);
        var tb = typeof b.proposedAt === 'number' ? b.proposedAt : Date.parse(b.proposedAt || 0);
        return tb - ta;
      },
      limit: 40
    },
    found: {
      icon: '✅',
      caption: t('cap_found', 'Giochi recuperati grazie alla community — compra ora prima che finiscano.'),
      filter: function(h){
        if (h.status !== 'found') return false;
        // #1b: durante la finestra di vantaggio (72h) la hunt NON compare nella vista pubblica
        // "Trovati" — tranne che per chi la seguiva/proponeva, che la vede subito col countdown.
        var inWindow = h.foundPublicAt && Date.parse(h.foundPublicAt) > Date.now();
        if (inWindow) {
          var mine = state.myHuntSlugs && state.myHuntSlugs.indexOf(h.slug) !== -1;
          if (!mine) return false;
        }
        return true;
      },
      sort: function(a,b){
        var pa = a.purchasableSince && !a.purchasablePaused ? 0 : 1;
        var pb = b.purchasableSince && !b.purchasablePaused ? 0 : 1;
        if(pa !== pb) return pa - pb;
        var ta = typeof a.updatedAt === 'number' ? a.updatedAt : Date.parse(a.updatedAt || 0);
        var tb = typeof b.updatedAt === 'number' ? b.updatedAt : Date.parse(b.updatedAt || 0);
        return tb - ta;
      },
      limit: null
    },
    impossible: {
      icon: '💎',
      caption: t('cap_oop', 'Giochi fuori catalogo — rari, da collezionisti. Se ne trovi uno, segnalacelo.'),
      filter: function(h){ return h.status === 'out_of_print' || h.status === 'unavailable'; },
      sort: function(a,b){ return (b.froggerCount||0) - (a.froggerCount||0); },
      limit: null
    },
    all: {
      icon: '📚',
      caption: t('cap_all', 'Tutte le hunt della community — piu\' recenti e attive in alto.'),
      filter: function(){ return true; },
      sort: function(a,b){
        var order = { found: 1, ordered: 2, searching: 3, proposed: 4, out_of_print: 5, unavailable: 6 };
        var oa = order[a.status] || 9, ob = order[b.status] || 9;
        if(oa !== ob) return oa - ob;
        return (b.froggerCount || 0) - (a.froggerCount || 0);
      },
      limit: null
    }
  };

  function renderCatalog(){
    var grid = document.getElementById('fhCatGrid');
    var totalEl = document.getElementById('fhCatTotal');
    var emptyEl = document.getElementById('fhCatEmpty');
    var captionText = document.getElementById('fhCatCaptionText');
    var captionIco = document.querySelector('.fh-cat__caption-ico');
    if(!grid) return;

    var seg = CAT_SEGS[__fhCatState.seg] || CAT_SEGS.hot;
    var q = (__fhCatState.q || '').trim().toLowerCase();

    // Se l'utente cerca per nome, IGNORA il filtro segmento — vuole trovare quel gioco ovunque sia.
    // Il segmento serve per browsing (mostrami i Caldi), non per limitare la ricerca.
    var filtered = __fhAllHunts.filter(function(h){
      if(q){
        var nameNorm = decodeHtmlEntities(h.name || '').toLowerCase();
        if(nameNorm.indexOf(q) === -1) return false;
        return true; // Match nome basta — ignora seg.filter
      }
      if(!seg.filter(h)) return false;
      return true;
    });
    // Un solo punto per tutti i segmenti: i giochi che HO gia' preso finiscono in fondo,
    // qualunque sia l'ordinamento del segmento.
    filtered.sort(purchasedLast(seg.sort));
    if(seg.limit && !q) filtered = filtered.slice(0, seg.limit); // Con query mostra TUTTI i match

    // Aggiorna didascalia guida
    if(captionText) captionText.textContent = seg.caption;
    if(captionIco) captionIco.textContent = seg.icon;

    if(totalEl) totalEl.textContent = filtered.length + ' ' + (filtered.length === 1 ? t('gioco', 'gioco') : t('giochi', 'giochi'));
    // Empty state intelligente: card visiva con anteprima hunt trovate in altre sezioni
    if(emptyEl){
      if (filtered.length > 0) {
        emptyEl.hidden = true;
        emptyEl.classList.remove('fh-cat__empty--rich');
      } else if (q) {
        var globalMatches = __fhAllHunts.filter(function(h){
          var nameNorm = decodeHtmlEntities(h.name || '').toLowerCase();
          return nameNorm.indexOf(q) !== -1;
        });
        if (globalMatches.length > 0) {
          // Per ogni segmento diverso dal corrente, conta i match
          var segLabels = { hot:'🔥 Caldi', popular:'📈 Popolari', new:'🆕 Appena proposti', found:'✅ Trovati', impossible:'💎 Introvabili', all:'📚 Tutti' };
          var order = ['found','popular','new','hot','impossible','all'];
          var segMatches = [];
          order.forEach(function(k){
            if (k === __fhCatState.seg) return;
            var def = CAT_SEGS[k];
            if (!def) return;
            var n = globalMatches.filter(def.filter).length;
            if (n > 0) segMatches.push({ key:k, label:segLabels[k], count:n });
          });
          // Preview: prime 3 hunt matched, con stato colorato
          var statusColors = { proposed:['#DBEAFE','#1E40AF'], searching:['#FEF3C7','#92400E'], ordered:['#EDE9FE','#5B21B6'], found:['#D1FAE5','#065F46'], out_of_print:['#E5E7EB','#374151'], unavailable:['#FEE2E2','#991B1B'] };
          var statusLabels = { proposed:'Proposto', searching:'In ricerca', ordered:'Ordinato', found:'Trovato', out_of_print:'Fuori catalogo', unavailable:'Non disponibile' };
          var previewList = globalMatches.slice(0, 3).map(function(h){
            var cImg = h.image || h.thumbnail || '';
            var thumb = cImg ? '<img class="fh-cat__empty-preview-thumb" src="https://wsrv.nl/?url='+encodeURIComponent(cImg)+'&w=80&h=80&fit=cover&output=webp&q=80" alt="" loading="lazy">' : '<div class="fh-cat__empty-preview-thumb fh-cat__empty-preview-thumb--empty"></div>';
            var sCol = statusColors[h.status] || ['#F1F5F9','#334155'];
            var sLbl = statusLabels[h.status] || h.status;
            return '<button type="button" class="fh-cat__empty-preview" data-empty-preview="'+escHtml(h.slug)+'">'+
              thumb +
              '<div class="fh-cat__empty-preview-body">'+
                '<div class="fh-cat__empty-preview-name">'+escHtml(decodeHtmlEntities(h.name || ''))+'</div>'+
                '<div class="fh-cat__empty-preview-meta">'+
                  '<span class="fh-cat__empty-preview-status" style="background:'+sCol[0]+';color:'+sCol[1]+'">'+sLbl+'</span>'+
                  ' <span class="fh-cat__empty-preview-frog">👥 '+(h.froggerCount||0)+'</span>'+
                '</div>'+
              '</div>'+
              '<span class="fh-cat__empty-preview-arrow">→</span>'+
            '</button>';
          }).join('');
          var moreLbl = globalMatches.length > 3 ? '<div class="fh-cat__empty-more">+'+(globalMatches.length-3)+' altr'+(globalMatches.length-3===1?'a':'e')+'</div>' : '';
          var chipsHtml = segMatches.map(function(s){
            return '<button type="button" class="fh-cat__empty-chip" data-goto-seg="'+s.key+'">'+s.label+' <span class="fh-cat__empty-chip-n">'+s.count+'</span></button>';
          }).join('');
          emptyEl.classList.add('fh-cat__empty--rich');
          emptyEl.innerHTML =
            '<div class="fh-cat__empty-icon">🔍</div>'+
            '<h3 class="fh-cat__empty-title">Non c\'e\' <span class="fh-cat__empty-q">"'+escHtml(q)+'"</span> qui</h3>'+
            '<p class="fh-cat__empty-sub">Ma <b>'+globalMatches.length+'</b> risultat'+(globalMatches.length===1?'o':'i')+' altrove:</p>'+
            '<div class="fh-cat__empty-previews">'+previewList+moreLbl+'</div>'+
            (chipsHtml ? '<div class="fh-cat__empty-chips">'+chipsHtml+'</div>' : '');
          emptyEl.hidden = false;
          // Bind chip → cambia segmento
          emptyEl.querySelectorAll('[data-goto-seg]').forEach(function(btn){
            btn.onclick = function(){
              __fhCatState.seg = btn.getAttribute('data-goto-seg');
              document.querySelectorAll('[data-seg]').forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-seg') === __fhCatState.seg); });
              renderCatalog();
            };
          });
          // Bind preview → apri detail modal
          emptyEl.querySelectorAll('[data-empty-preview]').forEach(function(btn){
            btn.onclick = function(){
              var slug = btn.getAttribute('data-empty-preview');
              if (typeof openDetailModal === 'function') openDetailModal(slug);
            };
          });
        } else {
          emptyEl.classList.add('fh-cat__empty--rich');
          emptyEl.innerHTML =
            '<div class="fh-cat__empty-icon">🕵️</div>'+
            '<h3 class="fh-cat__empty-title">Non l\'abbiamo <span class="fh-cat__empty-q">"'+escHtml(q)+'"</span></h3>'+
            '<p class="fh-cat__empty-sub">Nessun Frogger ha ancora proposto questo gioco.</p>'+
            '<button type="button" class="fh-cat__empty-cta" onclick="document.getElementById(\'fhProposeBtn\')?.click()">+ Proponilo tu</button>';
          emptyEl.hidden = false;
        }
      } else {
        emptyEl.classList.remove('fh-cat__empty--rich');
        emptyEl.innerHTML = 'Nessun gioco per questo filtro. Prova a cambiare stato o difficolta\'.';
        emptyEl.hidden = false;
      }
    }

    var followed = new Set(state.myHuntSlugs || []);
    grid.innerHTML = filtered.map(function(h, i){ return gcardHtml(h, i + 1, followed); }).join('');

    // Wire follow + open buttons
    grid.querySelectorAll('[data-gc-follow]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var slug = btn.getAttribute('data-gc-follow');
        if(typeof handleFollowClick === 'function') handleFollowClick(slug);
      });
    });
    grid.querySelectorAll('[data-gc-open]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var slug = btn.getAttribute('data-gc-open');
        if(slug && typeof openDetailModal === 'function') openDetailModal(slug);
      });
    });
  }

  function gcardHtml(h, rank, followed){
    var img = h.image || h.thumbnail || '';
    var imgSrc = img ? 'https://wsrv.nl/?url=' + encodeURIComponent(img) + '&w=400&h=400&fit=cover&output=webp&q=82' : '';
    var isBuyable = h.status === 'found' && h.purchasableSince && !h.purchasablePaused
      && h.shopifyProductUrl && typeof isValidShopUrl === 'function' && isValidShopUrl(h.shopifyProductUrl);
    var isPaused = h.status === 'found' && h.purchasablePaused;
    var statusLabels = { proposed:t('s_nuovo','Nuovo'), searching:t('s_ricerca','In ricerca'), ordered:t('s_ordinato','Ordinato'), found:isPaused?t('s_esaurito','Esaurito'):t('s_trovato','Trovato'), out_of_print:t('s_fuori','Fuori catalogo'), unavailable:t('s_fuori','Fuori catalogo') };
    var isFollowed = followed.has(h.slug);

    var DIFF_MAP = {
      easy:      {label:'🟢 Facile',       bg:'#d1fae5', color:'#065f46'},
      medium:    {label:'🟡 Media',        bg:'#fef3c7', color:'#92400e'},
      hard:      {label:'🟠 Difficile',    bg:'#fed7aa', color:'#9a3412'},
      very_hard: {label:'🔴 Molto diff.',   bg:'#fee2e2', color:'#991b1b'},
      impossible:{label:'💎 Rarissimo',    bg:'#1f2937', color:'#f4c430'}
    };
    var diffHtml = (h.difficulty && DIFF_MAP[h.difficulty])
      ? '<span class="fh-gc__diff" style="background:'+DIFF_MAP[h.difficulty].bg+';color:'+DIFF_MAP[h.difficulty].color+'">'+DIFF_MAP[h.difficulty].label+'</span>'
      : '';

    // Situation: chip visibile subito sulla card (auto-cancellato dal cron a stock arrivato)
    var SIT_MAP = {
      awaiting:     {label:'🕐 In arrivo',       bg:'#FED7AA', color:'#7C2D12'},
      ks_incoming:  {label:'🚀 KS in arrivo',    bg:'#EDE9FE', color:'#5B21B6'}
    };
    var sitHtml = (h.situation && SIT_MAP[h.situation])
      ? '<span class="fh-gc__diff" style="background:'+SIT_MAP[h.situation].bg+';color:'+SIT_MAP[h.situation].color+'">'+SIT_MAP[h.situation].label+'</span>'
      : '';

    var ctaHtml;
    if(isBuyable){
      ctaHtml = '<a class="fh-gc__cta fh-gc__cta--buy" href="' + escHtml(h.shopifyProductUrl) + '" onclick="event.stopPropagation()">&rarr; Compra ora</a>';
    } else if(h.status === 'found'){
      // Trovato ma non comprabile ora (esaurito/paused OPPURE senza URL prodotto valido)
      // — CTA dedicata: seguire per essere avvertiti quando torna comprabile
      var alreadyF = isFollowed;
      ctaHtml = '<button type="button" class="fh-gc__cta fh-gc__cta--notify" data-gc-follow="'+h.slug+'">'
        + (alreadyF ? '&#x2713; Ti avvisiamo' : '&#x1F514; Avvisami quando torna') + '</button>';
    } else if(h.status === 'out_of_print' || h.status === 'unavailable'){
      ctaHtml = '<span class="fh-gc__cta fh-gc__cta--info">&#x1F48E; Da collezionisti</span>';
    } else if(isFollowed){
      ctaHtml = '<button type="button" class="fh-gc__cta fh-gc__cta--followed" data-gc-follow="'+h.slug+'">&#x2713; Frogger</button>';
    } else {
      ctaHtml = '<button type="button" class="fh-gc__cta fh-gc__cta--follow" data-gc-follow="'+h.slug+'">&#x1F49A; Diventa Frogger</button>';
    }

    var cleanName = decodeHtmlEntities(h.name);
    // Fase A: badge "Da [nickname] che segui" se la hunt è proposta da un Frogger che seguo
    var followedByBadge = '';
    var proposerCid = String(h.proposedByCustomerId || '');
    if(proposerCid && __fhBoardMyFollows.has(proposerCid) && __fhFollowedNicknames[proposerCid]){
      followedByBadge = '<div class="fh-gc__followed-by" title="Segui questo Frogger">'
        + '&#x1F464; Da <b>' + escHtml(__fhFollowedNicknames[proposerCid]) + '</b> che segui'
        + '</div>';
    }
    // Nota di stato: e' l'unica frase che dice cosa sta succedendo davvero
    // ("in attesa di una data precisa", "partecipiamo alla campagna"). Finora si
    // vedeva solo aprendo la scheda, e infatti l'aggiornamento finiva nei commenti.
    var noteHtml = '';
    if(h.statusNote){
      // Accorcio qui e non con -webkit-line-clamp: quel taglio non mette i puntini
      // in tutti i browser e lascia in vista mezza riga. Il testo intero resta nel
      // tooltip e dentro la scheda. Meno spazio sul telefono, quindi meno testo.
      var maxLen = (window.innerWidth && window.innerWidth < 640) ? 46 : 70;
      var nota = h.statusNote.trim();
      if(nota.length > maxLen){
        var cut = nota.slice(0, maxLen);
        var sp = cut.lastIndexOf(' ');
        nota = (sp > maxLen * 0.6 ? cut.slice(0, sp) : cut).replace(/[.,;:\s]+$/, '') + '\u2026';
      }
      noteHtml = '<p class="fh-gc__note" title="' + escHtml(h.statusNote) + '"><span aria-hidden="true">&#x1F4AC;</span> ' + escHtml(nota) + '</p>';
    }

    return '<article class="fh-gc' + (followedByBadge ? ' fh-gc--followed-by' : '') + '" data-slug="'+h.slug+'">' +
      '<div class="fh-gc__cover" data-gc-open="'+h.slug+'">' +
        (imgSrc ? '<img src="'+imgSrc+'" alt="" loading="lazy">' : '') +
        '<span class="fh-gc__status fh-gc__status--'+(isPaused?'searching':h.status)+'">'+statusLabels[h.status]+'</span>' +
      '</div>' +
      '<div class="fh-gc__body">' +
        followedByBadge +
        '<h3 class="fh-gc__name" data-gc-open="'+h.slug+'">'+escHtml(cleanName)+'</h3>' +
        ((diffHtml || sitHtml) ? '<div class="fh-gc__meta">' + diffHtml + sitHtml + '</div>' : '') +
        noteHtml +
        '<div class="fh-gc__froggers">&#x1F465; <b>'+(h.froggerCount||0)+'</b> Frogger</div>' +
        ctaHtml +
      '</div>' +
    '</article>';
  }

  function initCatalogFilters(){
    // Chip segmento (Caldi / Popolari / Nuovi / Trovati / Tutti)
    document.querySelectorAll('[data-cat-seg]').forEach(function(chip){
      chip.addEventListener('click', function(){
        document.querySelectorAll('[data-cat-seg]').forEach(function(c){ c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        __fhCatState.seg = chip.getAttribute('data-cat-seg');
        renderCatalog();
      });
    });
    // Search catalogo (debounced) — cerca tra le hunt già proposte
    var searchInput = document.getElementById('fhCatSearch');
    if(searchInput){
      var t;
      searchInput.addEventListener('input', function(){
        clearTimeout(t);
        t = setTimeout(function(){
          __fhCatState.q = searchInput.value;
          renderCatalog();
        }, 200);
      });
    }
  }

  // Decodifica entita' HTML comuni presenti nei nomi salvati vecchi (es. "Ada&#039;s Dream")
  // Necessario perché alcuni record hanno già HTML entities nel valore raw del KV.
  function decodeHtmlEntities(str){
    if(!str) return '';
    return String(str)
      .replace(/&#(\d+);/g, function(_, code){ return String.fromCharCode(parseInt(code, 10)); })
      .replace(/&#x([0-9a-f]+);/gi, function(_, code){ return String.fromCharCode(parseInt(code, 16)); })
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'");
  }

  // FAB + bottom-sheet mobile per la sidebar
  function initMineSheet(){
    var fab = document.getElementById('fhMineFab');
    var aside = document.getElementById('fhMineAside');
    var scrim = document.getElementById('fhMineScrim');
    var closeBtn = document.getElementById('fhMineSheetClose');
    if(!fab || !aside) return;
    function open(){
      aside.classList.add('is-open');
      if(scrim){ scrim.hidden = false; requestAnimationFrame(function(){ scrim.classList.add('is-open'); }); }
      document.body.style.overflow = 'hidden';
    }
    function close(){
      aside.classList.remove('is-open');
      if(scrim){ scrim.classList.remove('is-open'); setTimeout(function(){ scrim.hidden = true; }, 240); }
      document.body.style.overflow = '';
    }
    fab.addEventListener('click', open);
    if(closeBtn) closeBtn.addEventListener('click', close);
    if(scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && aside.classList.contains('is-open')) close(); });
  }

  // Hero buttons
  document.addEventListener('DOMContentLoaded', function(){
    loadMyProfileStats();
    initHunterModal();
    initStickyCta();
    initRailIndicators();
    initTabRail();
    initMineSheet();
    initCatalogFilters();
    // Classifica Frogger: pulsante 🏆 nel masthead apre modal
    initBoardModal();
    initTopbarCta();
    // Preload TUTTE E 4 le tab in background: tab-switch istantaneo senza flash + popola hero strip
    setTimeout(function(){ loadLeaderboard('catalyst'); }, 400);
    setTimeout(function(){ loadLeaderboard('sniper'); }, 900);
    setTimeout(function(){ loadLeaderboard('fresh'); }, 1400);
    setTimeout(function(){ loadLeaderboard('influencer'); }, 1900);
    // Widget "Dai tuoi seguiti" nella sidebar
    setTimeout(loadMyNetworkHunts, 600);
    initNewPill();
    var heroBtn = document.getElementById('fhHeroPropose');
    if(heroBtn){
      heroBtn.addEventListener('click', function(){
        var existing = document.getElementById('fhProposeCta');
        if(existing) existing.click();
      });
    }
    // "Esplora tutti": apre l'accordion E scrolla, no doppio tap
    var exploreBtn = document.getElementById('fhHeroExplore');
    if(exploreBtn){
      exploreBtn.addEventListener('click', function(){
        var details = document.getElementById('fh-explore-all');
        if(details){
          details.open = true;
          // scroll dopo che l'accordion ha iniziato ad aprirsi
          setTimeout(function(){
            details.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 60);
        }
      });
    }
  });

  // V2: sostituisco renderCard cosi\' ogni card dentro la grid e\' una rcard quadrata
  // (renderGrid continua a usare i filtri esistenti, ma le card sono in stile nuovo)
  if (typeof renderCard === 'function') {
    renderCard = function(h){
      try { return railCardHtml(h, {}); }
      catch(e){ console.error('rcard error:', e); return ''; }
    };
  }

  // Hook in renderGrid: dopo ogni render, popola anche i rail e bind dei click
  var _origRenderGrid = renderGrid;
  renderGrid = function(){
    _origRenderGrid.apply(this, arguments);
    try { bindRailEvents(); } catch(e){}
    try { buildAndRenderRails(); } catch(e){ console.error('Rails render error:', e); }
  };

})();
